/**
 * tmm-api admin DTOs — vendored from tmm-api `3a2d9f5f`, blob `15d368c4a0a14f32559481bce26dfcdce4a7b17e` (TMMPDM-0111).
 * TMMPDM-0113: the merchant-knowledge section at the end of this file (merchant patterns, naming
 * quality, institution requests) is vendored from tmm-api `f7c843fb`, blob
 * `f2a3324a3ea15f9fd036f87de0401cbfdee9b7ee` (TMMAPI-0194 and TMMAPI-0195 shipped; TMMPDM-0112 typed it
 * from their specs at `9ae13265`). The reconciliation is the TMMPDM-0113 delivery's Step 0 table.
 * Nothing else here changed; the rest stays pinned to `3a2d9f5f`.
 * TMMAPI-0181 U5 has shipped (`4f100e18`): the tickets and the announcements below are now typed from
 * that YAML (`Ticket`, `TicketUpdate`, `TicketAttachment`, `TicketList`, `Announcement`,
 * `AnnouncementList`, `AnnouncementRequest`, `AnnouncementPublishRequest`), not from the spec. The
 * only admin routes added since `56a8fa38` are `/v1/admin/tickets…` and `/v1/admin/announcements…`; no
 * other route or schema this console reads changed. The reconciliation is the TMMPDM-0111 delivery's
 * Step 0 table.
 * TMMPDM-0110 pinned `56a8fa38`, blob `1b9016c0868d2bf479064f5d6a3ec928922d7d40`.
 * Since `355a1eb3` that YAML gained only member routes and schemas (`/v1/me/assistant/…`, the alias
 * removal choice): no admin route or schema this console reads changed. TMMAPI-0181 is still typed
 * from its SPEC at `56a8fa38`, blob `5ab13d521d2161ca0be14829c03608d087ceece9` (no 0181 shipped doc
 * in the local clone): item 30 now fixes the ticket wire contract to TMMPDM-0109's reading (bare
 * `{number}`, `TICKET_NOT_FOUND`, `TICKET_TRANSITION_INVALID {current}`, `TICKET_DUPLICATE_INVALID`,
 * the requester's name and email, `authorName`); item 32a adds the announcements and U7 item 46 the
 * ticket attachments, whose admin paths and JSON the spec names only in part: the console's reading
 * is recorded in the TMMPDM-0110 delivery's Part B, C and D sections.
 * TMMPDM-0109 pinned `355a1eb3`, blob `f04045f7227d54a0fb067d5bc634b468748b6925`.
 * Since `c3e9d5f4` that YAML changed only member routes and schemas (genesis dismiss/resume, import
 * preview fields) and the assignment POST's description (0176's "verify first", already handled by
 * TMMPDM-0108): nothing this console reads changed shape. The tickets section at the end of this file
 * and the two AI features are typed from tmm-api's SPEC, not its YAML: TMMAPI-0181 at `355a1eb3`, blob
 * `6b0978edb22737f84d16f2ddc49bc23ff18c6e60` (`docs/specs/TMMAPI-0181-crich04-financial-assistant-spec.md`;
 * U5 items 28–33, U2 item E, U4 item 23), ahead of U5's merge. That YAML carries no ticket schema and
 * no assistant feature yet; where the spec names an operation but not its path or JSON, the console's
 * choice is recorded in the TMMPDM-0109 delivery's Step 0 table.
 * TMMPDM-0108 pinned `c3e9d5f4`, blob `fe19ae979bae874185e9eee627be545b34998725`. 0174
 * adds `structuredOutputs?` to `AiModelCatalogRow`, absent when unknown (never null); `false` means
 * the model can't be assigned. The add's 409 `AI_MODEL_NOT_SUPPORTED` gains `details.reason`
 * `NO_STRUCTURED_OUTPUT`, and the assignment POST's 400 `fields.model` gains the structured-outputs
 * refusal (0176 item 11, spec-only: unknown support is refused too, "verify the model first");
 * these are route descriptions, not schemas. Nothing else this console calls changed shape.
 * TMMPDM-0105 pinned `a003886d` (origin/main after the TMMAPI-0172 ship),
 * blob `5850028bf30e4335c806ca8f66130a679298b37b`. 0172 adds `efforts?`, `lifecycle?` and
 * `retiresAt?` to `AiModelCatalogRow`, each absent when unknown (never null); `lifecycle` is a plain
 * string on the YAML (its description names `active`, `deprecated`, `retired`). The add's 409
 * `AI_MODEL_NOT_SUPPORTED` (`details.reason` `RETIRED` | `NO_EFFORT`) and the assignment POST's 400
 * `fields.effort` / `fields.model` are route descriptions, not schemas. 0172's `identityKey?` on the
 * register lines is in a schema this console doesn't read. Nothing else this console calls changed.
 * TMMPDM-0104 pinned `12513dae` (origin/main after the TMMAPI-0171 ship), blob
 * `ef127fbce5c846c74aabe31afb634531a41a163f`. 0171 adds the AI
 * model catalogue (`AiModelCatalogRow`, `AiModelCatalogList`, `AiModelCatalogAddRequest`,
 * `AiModelCatalogPatchRequest`), replaces `supportedModels` with `modelsByTier`
 * (`AiModelAssignmentModelsByTier`), adds `effort` to the assignment row (required) and write
 * (optional), and adds `truncated` / `refused` to the reconciliation row (required). The catalogue
 * PATCH's `note` is the one nullable admin request field (`null` clears it). Nothing else this
 * console calls changed shape.
 * TMMPDM-0102 pinned `40bf78af` (origin/main at that re-pin).
 * The OpenAPI blob `eda057ac29c8b19ab94771a0d37f63566d56766a` carries the TMMAPI-0167 ship
 * (`f26b926a`, "request bodies say what null means"); the later docs-only `4b6d7589` keeps the
 * same blob (docs/design/REFERENCE-tmm-api-contract-source.md). 0167 changed request schemas
 * only: a plain nullable request field is now optional and not nullable (`field?: T`, omit for
 * the default or to leave it unchanged), and no admin request field is nullable. Request types
 * here carry no `| null`; a field the console always sends stays required. The model-assignment
 * schemas are renamed `AiModelAssignmentCreateRequest` (our `AiModelAssignmentWrite`),
 * `AiModelAssignmentList` (our `AiModelAssignmentsView`), `AiModelAssignmentRow` and
 * `AiModelAssignmentTier`, shapes unchanged. No response schema changed.
 * TMMPDM-0101 pinned `cd80708` / blob `03dec427ca2f2de4af791dd2dcfef09ea376111e` (the TMMAPI-0165
 * ship `26b93ffb`) and tightened the model-assignment and price-row fields. `current` on a tier
 * is `Row | null`. A response field the YAML omits from `required` and does not mark nullable is
 * `field?: T`.
 * TMMPDM-0098 pinned `c24bc75` / blob `4b478d74dad7babd4f66da7cbc3b9e21e9edcaf9` (TMMAPI-0163 and
 * 0164 U1) and typed Part B from the 0165 spec at `1fa01dd5`, blob `3a8095426533`, before 0165
 * shipped. 0164 U2 is member-app (`/v1/me/payee-order`, payee aliases, the import preamble); this
 * console calls none of them.
 * A required-nullable request field the console already omits when unset stays `field?: T | null`:
 * 0164's handlers still treat a missing key as null, and this console does not invent nulls
 * (superseded by TMMPDM-0102: no request field carries `| null`).
 * TMMPDM-0097 re-pins the partner ledger onto the previous YAML (`44827f50`, blob
 * `2e8ba5110f8a649bdc7eb764e2da91f7cc2773ca`). U6 (`8880d77`) edits the same file but only
 * member AI-wallet and analysis fields (`currency` / `failed` / `taxMinor` / `totalMinor` /
 * `autoRechargeLimit` / `debtMinor` / failure-reason names). No ledger schema this console reads
 * changed in that commit. On that previous pin, a ledger property with no `required` entry could
 * be absent and was never null, except `PartnerLedgerView.lastStatement` (`oneOf` a statement or null).
 * TMMPDM-0095 first typed the ledger from tmm-api's SPEC, not its YAML: TMMAPI-0162 at `c09f02b5`,
 * blob `88b75c8921f7` (`docs/specs/TMMAPI-0162-crich04-partner-ledger-and-trials-spec.md`; §G items
 * 21-22, §H item 24, §I items 26–30, §J item 31; `c95c4df4` added the `COLLECTION_CONFLICT` hold
 * kind), ahead of U3/U4's merge. The YAML pin then stayed `55f01cf6` / `80e85d15287a`.
 * TMMPDM-0096 re-pinned that SPEC (not the YAML) to tmm-api `a1b8cad7`, blob
 * `e0684d460697bc3c0c244adfd2d49e4b8acab509` (items 22a, 26a and 36b). The YAML pin stayed
 * `55f01cf6` / `80e85d15287a` because that YAML did not yet carry `payoutActionsRetired`.
 * TMMPDM-0094 re-pins from `a576a31a` / blob `1cb25e8ef1c5`: `taxIdStatus` (nullable, not `required`)
 * on `AffiliateAgreementView` and `ResellerAgreementView` (also `AgreementView` and
 * `PayoutMethodView`, which this console never reads); `POST /v1/admin/billing/payees/backfill`
 * answers `PayeeBackfillResult`; `AdminDeletionRow` gains the closed enum `lastErrorCode` (0160 U4).
 * Not typed here (follow-ups): `BillingAttention.attentionEntries`, `.deferredRefunds` (0161) and
 * `.erasuresAfterCommitPending` (0160), and `AdminDeletionRow.afterCommitPending` (0160).
 * TMMPDM-0093 re-pins from `f9fcac55` / blob `e24ae9c38589`: 0158's erase-now retries a `FAILED`
 * request (no shape change; `AdminDeletionRow.status` and `.lastError` gain descriptions);
 * 0159's attention view gains `unhandledEvents`, `skuReviewRequired`, `taxClassificationFailures`
 * and `reLostDisputes` (all four always present, `required`), and `POST /v1/admin/billing/skus/declare`
 * answers `SkuDeclarations`. `ParkedFeedEventView.reasonCode` gains `DISPUTE_FIELDS_MISSING`
 * (`ParkedReasonCode`). Not read here: `StatementView.taxRateBp` (removed, never typed),
 * `AiWalletEntryKind` `DISPUTE_*` and `BillingClientConfig.stripeCustomerEmails` (member routes).
 * TMMPDM-0092 re-pins from `b1f55fab` / blob `ce5273d5c827`: 0157's erase-now answers
 * `ImmediateErasureView`; the five 0156 U1 seller and terms settings ride the existing
 * product-settings shapes (string values keyed by setting name). No other shape changed.
 * TMMPDM-0091 re-pins from `092b43c5` / blob `7c1d94ee9fcf`: tmm-api calculates no tax (MM-D-139).
 * The card's tax rows and their routes are gone, and so is every tax rate and label
 * (offers, the granted controls, the price-book example); a statement's and revenue's `taxMinor` is
 * pay-api's recorded tax, shown as sent. 0157's routes are not called.
 * TMMPDM-0090 re-pins from `ade6f131` / blob `f24d3abaf751`: a card version lists its `violations`
 * (the publish rules it breaks now); card create takes its first `controls` (no tax: MM-D-137); the
 * agreement's `currency` is optional on the first agreement too (the adopted card's when absent);
 * the worksheet carries the customer's `bill` and both profit percents.
 * TMMPDM-0089 re-pins from `fb14a1a` / blob `6c6f896c5a23`: one rate card (a customer card version
 * holds our cost, wholesale and retail; bands are `AdminBandView`; `aiMarkupBp` is `aiRetailMarkupBp`);
 * the margin worksheet; per-currency processing fees; the four affiliate maximums on the card's
 * controls. Removed: our wholesale cards (`/v1/admin/billing/rate-cards/**`), the agreement's card
 * (it carries `currency` instead), and every guardrail and `noncompliant` field on cards, versions,
 * granted views and offers (a commission plan's own `noncompliant` stays). The 0153 shapes typed from
 * spec section G in TMMPDM-0088 now follow the YAML's `required:` lists.
 * TMMPDM-0088 re-pins from `6e36a38` / blob `a178bab4613e` to `fb14a1a`: customer card versions,
 * offers and the granted-card view swap AI included / minimum / monthly cap for the five AI wallet
 * terms; the ai-usage person row gains `wallet`; `POST …/people/{userId}/ai-credit` and
 * `GET /v1/admin/ai-cost-reconciliation` are new. `/v1/admin/import-presets/**` is new and not called.
 * TMMPDM-0087 re-pins from `7016188` / blob `51d9ba46f236` to `6e36a38` / blob `a178bab4613e`:
 * no route or shape this console calls changed. 0132's `AFFILIATE_PORTAL_NOT_CONFIGURED` and the
 * affiliate-invite description are on routes this console does not call; 0133 has no OpenAPI
 * change; 0134 adds member-import fields; 0135 adds `/v1/me` and virtual-account fields only.
 * TMMPDM-0084 re-pins from `2ba9d50` / blob `020049d57d8b` to 0130: `POST …/billing/provision` answers
 * `AdminTenantBillingState` (`billingProvisionedAt` required non-null, `clientConfig` required and
 * nullable); `TenantView.billingProvisionedAt` (always present, `string | null`) and
 * `TenantView.billingProvisioning` (optional: present only on the create's answer, never `null`);
 * 409 `BILLING_CONNECTION_CONFLICT`.
 * TMMPDM-0083 re-pins from `ff583e2` / blob `7a1713c8e9da` to 0128: descriptions only, no shape change;
 * `payouts.pendingMinor` is never negative (a negative carried balance never reduces it); the payouts
 * `retry-transfer` route (a call this console never makes) answers 200 with the unchanged attempt when
 * one was never handed off.
 * TMMPDM-0082 re-pins from `7daa6a1` / blob `50826548a2da` to 0127 and 0129: `ScopedBillingClientConfig`
 * and its two routes (the GET and the new `POST …/billing/client-config/refresh`); the tenant overview's
 * `payouts.pendingMinor` / `paidInPeriodMinor` read the reseller's real settlements and `pendingMinor`
 * can be negative (a carried negative balance); 502 `PLAN_CREATE_FAILED` where a plan is created.
 * TMMPDM-0080 re-pins from `9df14ad` / blob `8fbd5487b4d0` to 0126: `PayoutTransferStatus` gains
 * `CANCELLED`; `BillingAttention.feedStalled` (always present, `FeedStall | null`); a busy Dismiss
 * answers 503 `PARKED_EVENT_BUSY`; the AI minimum applies only beyond the included allowance (copy
 * only, no shape change); `ImportCommitResponse` is typed (a call this console never makes).
 * TMMPDM-0078 re-pins from `174e686` / blob `da89db2a5724` to 0122 to 0125: `AdminSubscriptionRow.
 * appliedPromotion` (always present, `null` when none; `AppliedPromotion`, every key present);
 * `end-promotion` answers 409 `PROMOTION_NOT_APPLIED` (it was 404 `PROMOTION_NOT_FOUND`). 0123's
 * `PARKED_EVENT_BUSY` / `REFUND_PARENT_NOT_MIRRORED` were already typed (TMMPDM-0076); the 0122
 * removals of `commissionLast30DaysMinor`, `revShareBp` and `plaidType` touch nothing this console reads.
 * 0125: 409 `PLAN_MAPPING_CONFLICT` where a plan is bound; `AffiliateAgreementView.commissionPlan` and
 * `ParkedFeedEventView.reasonCode` are now never `null` on the wire; both are typed non-null (TMMPDM-0079).
 * TMMPDM-0071 re-pins from b8547ce / blob `de1979ffa8e8` (TMMPDM-0067): the parked payment event
 * routes and views (`ParkedFeedEventView`, `ParkedFeedEventPage`, `ParkedEventNoteRequest`). The
 * view's keys are all `required` and the nullable ones are `[string, "null"]`: present-and-`null`,
 * never optional. `BillingAttention.skippedEvents` keeps its shape and now lists unresolved parked
 * events only. `commissionUntil` is gone from two affiliate/billing views this console never reads.
 * TMMPDM-0059 adopts TMMAPI-0116: takeover date, House flag, retained components and margin.
 * Re-pin when a shipped tmm-api unit changes a shape this console consumes;
 * never edit a shape without moving the pin.
 *
 * Nullable vs optional (CLAUDE.md): springdoc emits every view property as
 * optional; the rule applied here is the Java types' — counts and `*Minor`
 * amounts are primitives and ALWAYS present (`number`), dates that may be
 * unset are `?: string`, arrays are always present (possibly empty).
 * `TenantView` is the exception: `@JsonInclude(ALWAYS)`, so its unset keys are
 * present-and-`null` (TMMAPI-0074, MM-D-102). `ProductSettingView.value` is
 * present-and-`null` while unset (product-settings GET description).
 * TMMPDM-0020 re-pins to a0e8957 (TMMAPI-0075…0080): per-currency totals,
 * reseller assignment, tenant PATCH, product settings.
 * TMMPDM-0021: reseller agreement, one-call tenant create, reseller payouts
 * (same pin — TMMAPI-0076 shapes already on a0e8957).
 * TMMPDM-0022: reseller standing, transfer-tenants, deactivate (TMMAPI-0077 shapes
 * already on a0e8957).
 * TMMPDM-0025 re-pins to 8e2b0ab (TMMAPI-0081…0089): `TenantView.sellable`, standing clear,
 * reseller brand create; `effectiveFrom` is no longer sendable on an agreement write.
 * TMMPDM-0026 re-pins to bec7915 (TMMAPI-0090): reseller reactivate, `ResellerStandingView.reactivatedAt`;
 * `OfferView.tenantAgreementId` is gone from the contract.
 * TMMPDM-0028: the value lists the console renders (`SIGNUP_MODES`, `RESELLER_STANDING_STATES`,
 * `PAYOUT_*`, `TAX_DOCS_STATUSES`, `CHARGE_STATUSES`) are exported here for the catalog guard —
 * no shape change, same pin.
 * TMMPDM-0029: `TenantView.name` / `status` / `signupMode` / `createdAt` typed nullable, as the
 * YAML at bec7915 says — same pin.
 * TMMPDM-0030 re-pins to e60ba2e (TMMAPI-0094/0095): those four are non-null again;
 * `TenantView.sellableReason`; `ResellerStandingView.saasAuthStatus`.
 * TMMPDM-0032 re-pins to f358dc9 (TMMAPI-0096/0097, MM-D-105): our card's four reseller guardrails;
 * a reseller's own rate cards (`ResellerCard*`, preview);
 * `TenantView.rateCardId`; `sellableReason` gains `NO_RATE_CARD`, loses `NO_CURRENT_OFFER`;
 * `OfferView.resellerRateCardId`. The tenant
 * pricing routes answer 410 `PRICING_MOVED_TO_RATE_CARDS`: `PricingView` / `PricingHistory` are gone.
 * TMMPDM-0037 re-pins to 83fc3fd (TMMAPI-0098…0101, MM-D-105): the reseller's card on file and its
 * charges (`ResellerBillingCard`, `ResellerCharge*`); monthly settlements (`PayoutStatementView`
 * margin, affiliates, net, `charge`, `byLine`; `payoutStatus` `CHARGED`; hold `HOLD_RESELLER_UNPAID`);
 * `resellerMarginMinor` on revenue totals and statement lines; the standing loses its outstanding
 * amount and each month's repaid amount, and gains `officialLaunchOn` / `probationDeadline` /
 * `nextNoticeOn` and each month's shortfall charge; the agreement gains `officialLaunchOn`.
 * TMMPDM-0041 re-pins to 0aa1d34 (TMMAPI-0102…0104, MM-D-106): our card's four affiliate
 * guardrails; a reseller's affiliate commission plans (`CommissionPlan*`, preview); standing clear's
 * 409 `RESELLER_SUSPENDED_USE_REACTIVATE` and reactivate for a reseller saas-auth holds suspended
 * (descriptions only).
 * TMMPDM-0045 re-pins to 7647401 (TMMAPI-0107…0109): the admin AI usage report carries
 * `atOurPriceMicro`; `ResellerCharge.retryable`; 409 `COMMISSION_PLAN_NAME_TAKEN` on a plan write.
 * The affiliate views' `oneOf [ref, null]` and the import `BEFORE_OPENING` fields aren't read here.
 * TMMPDM-0042 re-pins to 73f5b67 (TMMAPI-0106): the affiliate list, detail, agreement, referrals,
 * codes, lifecycle and the per-reseller list. Unset fields are absent. `commissionPlan` and
 * `inForce` are always present and may be null. `PayoutHold` gains `HOLD_AFFILIATE_REVIEW`.
 * The list row has no approval or end date. The per-reseller row has no review-hold flag.
 * The deprecated all-currency commission integer on the list row is not mapped; read `performance`.
 * TMMPDM-0043 re-pins to 3d49b4f (TMMAPI-0105; `api/openapi.yaml` blob `a15eb633a0ff`): a plan's
 * bounty, milestones and caps (always present, `null` when unset); a preview month's `bountyMinor`
 * (`null` except the bounty's payment) and `capped`; `GET …/affiliates/{id}/earnings`;
 * `byReseller[].affiliateBonuses`; a settlement's `affiliateBountiesMinor`,
 * `affiliateMilestonesMinor` and `affiliateRecoveredMinor`. `netMinor` includes them.
 * `affiliateCommissionMinor` and `performance` stay recurring commission only.
 * `ChargeView.status` gains `PARTIALLY_REFUNDED`; this console does not read that schema.
 * TMMPDM-0048 re-pins to 007c742 (TMMAPI-0111; `api/openapi.yaml` blob `2b413b351136`).
 * `OfferView.selectable` and `notSelectableReason` are always present. `ResellerStandingView.outOfBand`
 * is always present (`null` when the two sides agree) and `currency` stays `string | null`.
 * Product-wide `FeatureUsageRow`s carry `atOurPricePartial` (absent on a person's).
 * TMMPDM-0053 re-pins from 007c742 / blob `2b413b35113699c41d9d9a27d296c3cf6e1c108d` to 95724290
 * (TMMAPI-0114; blob `b7814405e4513c8e647c975f12479ec5a1914ad1`). `editableFields` (required only
 * on TenantView by the YAML, otherwise optional) on `TenantView`, `RateCardView`, `ResellerCardView`, `CommissionPlanView`,
 * `ResellerAgreementView`, `CatalogView` and `AdminReseller` (`ResellerDto`). `version` (Java long,
 * always present) on those views except the tenant and the reseller. PATCH bodies gain optional
 * `version`. `PATCH …/agreement/current` is notes plus version and does not insert a version row.
 */

/** saas-auth's tenant status, passed through by tmm-api (a string on the YAML). */
export type TenantStatus = 'ACTIVE' | 'INACTIVE' | 'SUSPENDED';
/** saas-auth's signup mode, passed through by tmm-api (a string on the YAML). */
export type SignupMode = 'PUBLIC' | 'INVITE_ONLY' | 'ADMIN_CREATED_ONLY' | 'DISABLED';
export const SIGNUP_MODES: readonly SignupMode[] = [
  'PUBLIC',
  'INVITE_ONLY',
  'ADMIN_CREATED_ONLY',
  'DISABLED',
];

/**
 * `TenantView` (TMMAPI-0074, MM-D-102) — one flat, always-complete product tenant. Every key
 * is always written and `null` is written out: nullable, never optional. `id` is the saas-auth
 * tenant id (the member / invitation screens' id); `currency`, `aiEnabledDefault` and
 * `addonsActive` are tmm's. The console never branches on which backend owns a field.
 */
export interface TenantView {
  reseller: ResellerPair | null;
  id: number;
  slug: string;
  /** TMMAPI-0095: `name` / `status` / `signupMode` / `createdAt` are non-null (validated upstream). */
  name: string;
  status: TenantStatus;
  signupMode: SignupMode;
  resellerId: number | null;
  resellerName: string | null;
  emailFromName: string | null;
  emailFromAddress: string | null;
  emailSupportEmail: string | null;
  brandId: number | null;
  planId: number | null;
  /** saas-auth's ISO local date-time. */
  createdAt: string;
  /** ISO 4217, the tenant's billing currency. */
  currency: string;
  aiEnabledDefault: boolean;
  addonsActive: string[];
  /**
   * TMMAPI-0130 (MM-D-86): when the tenant's billing connection was first provisioned at pay-api, read
   * from tmm's row; always present, `null` until then. Present-and-`null`, never optional.
   */
  billingProvisionedAt: string | null;
  /**
   * TMMAPI-0130: the create's provisioning outcome. OPTIONAL: present only on the answer to the
   * create; the list, the detail and PATCH never carry it (never `null`).
   */
  billingProvisioning?: TenantBillingProvisioning;
  /**
   * TMMAPI-0082 (Java primitive, always written): false with no reseller, no current agreement,
   * no usable rate card (TMMAPI-0097), or a `currency` that is not the reseller's rate-card currency.
   */
  sellable: boolean;
  /**
   * TMMAPI-0095: why the tenant can't sell — the first failing cause; `null` exactly when
   * `sellable` is true. The console renders it and never works out a reason itself; a value
   * outside the list renders the unknown-reason fallback.
   */
  sellableReason: SellableReason | null;
  /**
   * TMMAPI-0115: the reseller's active price card id, or null before activation.
   * The read-only card panel uses the card list's published pricesTenant instead of this legacy field.
   */
  rateCardId: number | null;
  /**
   * TMMAPI-0114: the fields a PATCH may change. Always present (possibly empty). Currency is
   * listed until a subscription or an invitation carrying an offer locks it. No `version`.
   */
  editableFields: string[];
}

/** `TenantView.billingProvisioning`: both keys always present; `reason` is `null` on PROVISIONED. */
export interface TenantBillingProvisioning {
  outcome: 'PROVISIONED' | 'FAILED';
  reason: string | null;
}

export type SellableReason =
  'NO_RESELLER' | 'NO_AGREEMENT' | 'NO_RATE_CARD' | 'CURRENCY_NOT_PRICED';

/** `GET /v1/admin/tenants` — tmm-api's page; read `tenants`, not saas-auth's `content`. */
export interface TenantList {
  tenants: TenantView[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface TenantListQuery {
  q?: string | undefined;
  status?: TenantStatus | undefined;
  resellerId?: number | undefined;
  page?: number | undefined;
  size?: number | undefined;
}

export interface SubscriberCounts {
  active: number;
  activeMonthly: number;
  activeAnnual: number;
  trialing: number;
  newInPeriod: number;
  churnedInPeriod: number;
  comped: number;
}

export interface GuestCounts {
  activeSeats: number;
  chargedSeats: number;
}

export interface OfferCount {
  retailOfferId: number;
  subscribers: number;
}

export interface PromotionCount {
  code: string;
  redemptionsInPeriod: number;
}

/** Integer minor units in the tenant's currency (totals: see the spec's stated assumption). */
export interface DashboardRevenue {
  retailMinor: number;
  wholesaleMinor: number;
  upliftMinor: number;
  tenantShareMinor: number;
  platformShareMinor: number;
  refundsMinor: number;
  annualPrepaidMinor: number;
}

/**
 * TMMAPI-0127 (MM-D-107): the reseller's real monthly settlements, in the tenant's currency; both are
 * 0 for a tenant without a reseller. `pendingMinor` is every `PENDING` payable plus the latest
 * `CARRIED` one when that balance is positive (TMMAPI-0128: a negative carry never reduces it, so it is
 * never negative; the next settlement nets it).
 */
export interface DashboardPayouts {
  pendingMinor: number;
  paidInPeriodMinor: number;
  /** ISO date. Required. */
  nextCloseOn: string;
}

export interface DashboardPoint {
  /** ISO date. */
  date: string;
  activeSubscribers: number;
  retailMinor: number;
}

export interface DashboardAffiliates {
  active: number;
  referredActive: number;
  referredNewInPeriod: number;
  commissionMinor: number;
}

export interface DashboardAffiliateTop {
  affiliateId: number;
  displayName: string;
  referredActive: number;
  commissionMinor: number;
}

export type AddonBillingMode = 'CARD' | 'NET_FROM_PAYOUTS';

/** Typed, not rendered (TMMPDM-0017). Every field but `kind`/`name` is Java `@Nullable`, NON_NULL. */
export interface TenantAddonTile {
  kind: string;
  name: string;
  billingMode?: AddonBillingMode;
  termEnd?: string;
}

export interface AddonDashboard {
  active?: TenantAddonTile[];
  activeCount?: number;
  pastDueCount?: number;
  revenueYearMinor?: number;
}

/** `TenantDashboard` — one tenant's period figures; `totals` reuses the shape. */
export interface TenantDashboard {
  slug?: string;
  subscribers: SubscriberCounts;
  guests: GuestCounts;
  connectedAccounts: number;
  offers: OfferCount[];
  promotions: PromotionCount[];
  revenue: DashboardRevenue;
  payouts: DashboardPayouts;
  series: DashboardPoint[];
  affiliates: DashboardAffiliates;
  affiliatesTop: DashboardAffiliateTop[];
  /** Java `@Nullable` under NON_NULL — absent when the tenant has no add-on figures. */
  addons?: AddonDashboard;
}

/** Currency-free fleet counts (and the daily subscriber series). */
export interface DashboardCounts {
  subscribers: SubscriberCounts;
  guests: GuestCounts;
  connectedAccounts: number;
  addonsActive: number;
  addonsPastDue: number;
  affiliatesActive: number;
  affiliatesReferredActive: number;
  affiliatesReferredNewInPeriod: number;
  /** ISO date; absent when nothing is scheduled to close. */
  nextPayoutCloseOn?: string;
  series: SubscriberPoint[];
}

export interface SubscriberPoint {
  /** ISO date. */
  date: string;
  activeSubscribers: number;
}

export interface RetailPoint {
  /** ISO date. */
  date: string;
  retailMinor: number;
}

/** One currency's money totals on the fleet dashboard (never summed across currencies). */
export interface CurrencyTotals {
  currency: string;
  revenue: DashboardRevenue;
  payoutsPendingMinor: number;
  payoutsPaidInPeriodMinor: number;
  affiliateCommissionMinor: number;
  addonRevenueYearMinor: number;
  series: RetailPoint[];
}

export type ResellerStandingState = 'GOOD' | 'PROBATION' | 'DEACTIVATION_DUE' | 'DEACTIVATED';
export const RESELLER_STANDING_STATES: readonly ResellerStandingState[] = [
  'GOOD',
  'PROBATION',
  'DEACTIVATION_DUE',
  'DEACTIVATED',
];

export interface ResellerStandingSummary {
  state: ResellerStandingState;
}

export interface ResellerStateCount {
  state: ResellerStandingState;
  count: number;
}

/**
 * One evaluated month on `ResellerStandingView` (TMMAPI-0077). Each row carries its own
 * `currency` — never sum or convert across rows (MM-D-100). Amounts are primitives.
 * TMMAPI-0099: the repaid amount is gone; `shortfallChargeId` / `chargeStatus` are the month's
 * `MINIMUM_SHORTFALL` charge — `ALWAYS` written, both `null` when the month had no shortfall.
 */
export interface ResellerStandingMonth {
  month: string;
  currency: string;
  minimumMinor: number;
  earnedMinor: number;
  shortfallMinor: number;
  shortfallChargeId: number | null;
  chargeStatus: ResellerChargeStatus | null;
}

/**
 * `GET /v1/admin/resellers/{id}/standing` — `@JsonInclude(NON_NULL)`. State and months are always
 * present; probation dates are absent when unset. `currency` is `ALWAYS` written and `null` only for
 * a reseller with no agreement and no evaluated month (typed as such from TMMPDM-0037; TMMAPI-0111
 * publishes it `[string, "null"]`). No amount is formatted from it. TMMAPI-0099: the outstanding
 * amount is gone (a shortfall is charged to the reseller's card, never carried).
 */
export interface ResellerStandingView {
  /** TMMAPI-0119: exactly when the reactivate route accepts this standing. */
  reactivateOffered: boolean;
  /** TMMAPI-0116: ALWAYS present; open takeover window, null when unmanaged. */
  platformManagedSince: string | null;
  state: ResellerStandingState;
  currency: string | null;
  probationStartedOn?: string;
  probationEndsOn?: string;
  /**
   * TMMAPI-0100, each `ALWAYS` written and `null` when unset: the current agreement's official
   * launch (no month before it is evaluated, none without it); the day an open or short window is
   * judged (`PROBATION` / `DEACTIVATION_DUE`); the next day a standing email is due.
   */
  officialLaunchOn: string | null;
  probationDeadline: string | null;
  nextNoticeOn: string | null;
  /**
   * TMMAPI-0090: ISO date-time of the last reactivation; absent (NON_NULL) until the reseller is
   * reactivated. The minimum commitment restarts from then.
   */
  reactivatedAt?: string;
  months: ResellerStandingMonth[];
  /**
   * TMMAPI-0095: the reseller's status in saas-auth as tmm-api last saw it (its mirror, refreshed
   * about every 10 minutes and on reseller routes). Always written (`ALWAYS`); `null` when tmm-api
   * hasn't met the reseller or saas-auth deleted it.
   */
  saasAuthStatus: ResellerSaasAuthStatus | null;
  /**
   * TMMAPI-0111: the one out-of-band fact, always written. `ACTIVE_IN_SAAS_AUTH` is deactivated
   * here while saas-auth shows the reseller active. `SUSPENDED_IN_SAAS_AUTH` is saas-auth
   * suspended during a DEACTIVATION_DUE take-over. Ordinary suspension reads null.
   */
  outOfBand: ResellerOutOfBand | null;
}

export type ResellerOutOfBand = 'ACTIVE_IN_SAAS_AUTH' | 'SUSPENDED_IN_SAAS_AUTH';

export type ResellerSaasAuthStatus = 'ACTIVE' | 'SUSPENDED';

/**
 * One currency of a reseller's affiliate bounties and milestones earned in the dashboard window,
 * not voided (TMMAPI-0105). Positive magnitudes. No cross-currency sum is published.
 */
export interface AffiliateBonusTotals {
  currency: string;
  bountyMinor: number;
  milestoneMinor: number;
}

/** One reseller's roll-up on the fleet dashboard (`resellerId: null` = unassigned). */
export interface ResellerDashboard {
  tenant: TenantPair | null;
  resellerId: number | null;
  resellerName: string | null;
  tenantCount: number;
  counts: DashboardCounts;
  totals: CurrencyTotals[];
  /**
   * TMMAPI-0105: always present. One row per currency; `[]` for the tenants with no reseller.
   * Earned in the dashboard window, not voided.
   */
  affiliateBonuses: AffiliateBonusTotals[];
}

export interface FleetDashboard {
  /** Signed closed retained components, separately per currency (TMMAPI-0116). */
  retainedMargin: RetainedMargin[];
  counts: DashboardCounts;
  totals: CurrencyTotals[];
  tenants: TenantDashboard[];
  byReseller: ResellerDashboard[];
  /** Typed, not rendered (TMMPDM-0022). */
  resellersByState: ResellerStateCount[];
  /** TMMAPI-0098: unpaid reseller charges, one row per currency — never summed (TMMPDM-0038). */
  resellerChargesUnpaid: ResellerChargesUnpaid[];
}

export interface RetainedMargin {
  currency: string;
  netMinor: number;
}

/** `ResellerChargesUnpaid` (TMMAPI-0098, `UnpaidTotals`) — all primitive, always present. */
export interface ResellerChargesUnpaid {
  currency: string;
  count: number;
  amountMinor: number;
}

export interface DashboardQuery {
  /** ISO date, inclusive. Always sent. */
  from: string;
  /** ISO date, inclusive. Always sent. */
  to: string;
  tenantSlug?: string;
  resellerId?: number;
}

/**
 * `POST /v1/admin/tenants` — one-call create (TMMAPI-0076). `name` and `resellerId` are
 * required by the operation (else 400); `signupMode` defaults server-side to `INVITE_ONLY`,
 * `currency` to `USD`. The slug-only body is transitional and this console no longer sends it.
 */
export interface TenantCreateRequest {
  slug: string;
  name: string;
  resellerId: number;
  signupMode?: SignupMode;
  currency?: string;
}

/**
 * `PATCH /v1/admin/tenants/{slug}` — send only changed fields; never `kind`. TMMAPI-0167: an
 * omitted field is unchanged and `null` never clears, so none is sent as null.
 */
export interface TenantPatchRequest {
  name?: string;
  status?: TenantStatus;
  signupMode?: SignupMode;
  aiEnabledDefault?: boolean;
  currency?: string;
}

export interface TenantResellerRequest {
  resellerId?: number;
}

export interface BandView {
  from: number;
  to?: number;
  flatMinor: number;
  perUnitMinor: number;
}

/**
 * `AdminBandView` (TMMAPI-0154): one band of a card version with its three prices. `flatMinor` /
 * `perUnitMinor` are the retail (the customer's), `wholesale*` the reseller's cost and `cost*` ours
 * (product admin only). Views have no NON_NULL: `to` is always sent, `null` when open-ended.
 */
export interface AdminBandView {
  from: number;
  to: number | null;
  flatMinor: number;
  perUnitMinor: number;
  wholesaleFlatMinor: number;
  wholesalePerUnitMinor: number;
  costFlatMinor: number;
  costPerUnitMinor: number;
}

/** A commission plan's status (and, before TMMAPI-0154, our wholesale card's). */
export type RateCardStatus = 'DRAFT' | 'ACTIVE' | 'CLOSED';

/**
 * `BandInput`. TMMAPI-0154: the wholesale and cost columns are optional on the wire (absent is 0;
 * on a draft write, absent keeps the draft's value for the same range). The console always sends them.
 */
export interface BandInput {
  from: number;
  to?: number;
  flatMinor: number;
  perUnitMinor: number;
  wholesaleFlatMinor?: number;
  wholesalePerUnitMinor?: number;
  costFlatMinor?: number;
  costPerUnitMinor?: number;
}

export type PayoutCadence = 'WEEKLY' | 'MONTHLY';
export type PayoutMethod = 'MANUAL' | 'STRIPE_CONNECT_MANUAL' | 'STRIPE_CONNECT';
export type TaxDocsStatus = 'NOT_REQUIRED' | 'PENDING' | 'COLLECTED';
export const PAYOUT_CADENCES: readonly PayoutCadence[] = ['WEEKLY', 'MONTHLY'];
export const PAYOUT_METHODS: readonly PayoutMethod[] = [
  'MANUAL',
  'STRIPE_CONNECT_MANUAL',
  'STRIPE_CONNECT',
];
export const TAX_DOCS_STATUSES: readonly TaxDocsStatus[] = ['NOT_REQUIRED', 'PENDING', 'COLLECTED'];
/**
 * The payee's tax-ID status at pay-api (TMMAPI-0161), served beside `taxDocsStatus` on a partner's
 * agreement. For a partner with a pay-api payee the server holds payouts on this, not on the tax
 * documents; the console shows both as sent and composes no verdict from them.
 */
export type TaxIdStatus = 'NOT_REQUIRED' | 'PENDING' | 'VERIFIED' | 'MISMATCH';
export const TAX_ID_STATUSES: readonly TaxIdStatus[] = [
  'NOT_REQUIRED',
  'PENDING',
  'VERIFIED',
  'MISMATCH',
];

/**
 * `ResellerAgreementView` (TMMAPI-0076) — `@JsonInclude(NON_NULL)`. Primitives and
 * `currency` / `createdByAdmin` / `effectiveFrom` are always present; `payoutAccountRef`,
 * `connectTenantSlug`, `endedAt` and `notes` are absent when null. TMMAPI-0100: `officialLaunchOn` (a date), absent while none is set.
 * TMMAPI-0161: `taxIdStatus` is nullable and not `required` in the YAML (null for a partner without a
 * pay-api payee), so it is read as absent, `null` or a value.
 */
export interface ResellerAgreementView {
  id: number;
  resellerId: number;
  /** TMMAPI-0154: the minimum's currency (the agreement no longer carries a rate card). */
  currency: string;
  officialLaunchOn?: string;
  payoutCadence: PayoutCadence;
  minPayoutMinor: number;
  payoutMethod: PayoutMethod;
  payoutAccountRef?: string;
  taxDocsStatus: TaxDocsStatus;
  taxIdStatus?: TaxIdStatus | null;
  connectTenantSlug?: string;
  monthlyMinimumMinor: number;
  probationMonths: number;
  effectiveFrom: string;
  endedAt?: string;
  notes?: string;
  createdByAdmin: string;
  createdAt: string;
  /**
   * TMMAPI-0114: Java `long`, always written. `editableFields` is `notes` while this version is
   * in force, otherwise empty.
   */
  version: number;
  editableFields: string[];
}

/** `GET …/resellers/{id}/agreement` — `@JsonInclude(ALWAYS)`; `current` is null with no agreement. */
export interface ResellerAgreementList {
  current: ResellerAgreementView | null;
  history: ResellerAgreementView[];
}

/**
 * `POST …/resellers/{id}/agreement` — required `payoutCadence` (Java `@NotNull`). TMMAPI-0154: no
 * card; `currency` is 3 letters and, absent on a later version, carries the current version's.
 * TMMAPI-0155: optional on the first agreement too — absent, it is the adopted card's currency; with
 * no adoption either, 400 `VALIDATION_FAILED`.
 * Optional fields omitted when blank. The YAML still lists `effectiveFrom`, but a version always
 * takes effect now (TMMAPI-0084: past or future → 400), so it is deliberately not typed here —
 * the console never sends it (TMMPDM-0025).
 * `officialLaunchOn` (TMMAPI-0100): absent carries the current version's launch;
 * a new value is the 1st of a month after today, UTC (400 `VALIDATION_FAILED` otherwise); never cleared.
 */
export interface ResellerAgreementWriteRequest {
  currency?: string;
  payoutCadence: PayoutCadence;
  minPayoutMinor?: number;
  payoutMethod?: PayoutMethod;
  taxDocsStatus?: TaxDocsStatus;
  connectTenantSlug?: string;
  monthlyMinimumMinor?: number;
  probationMonths?: number;
  notes?: string;
  officialLaunchOn?: string;
}

/**
 * `PATCH …/resellers/{id}/agreement/current` (TMMAPI-0114) — notes on the version in force.
 * Does not insert a version row. The console sends only `notes` and `version`; any other field
 * (including `officialLaunchOn`) is `AGREEMENT_IMMUTABLE` and nothing is applied. TMMAPI-0167:
 * an omitted field is unchanged; emptied notes are sent as `""`, which tmm-api stores as none.
 */
export interface ResellerAgreementNotesRequest {
  notes?: string;
  version?: number;
}

/** `POST …/resellers/{id}/standing/clear` — `reason` required, 1–500 characters (TMMAPI-0084). */
export interface ResellerStandingClearRequest {
  reason: string;
}

/** `POST …/resellers/{id}/reactivate` — `reason` required, 1–500 characters (TMMAPI-0090). */
export interface ResellerReactivateRequest {
  reason: string;
}

export type OfferStatus = 'ACTIVE' | 'CLOSED';
export type BillingInterval = 'MONTH' | 'YEAR';
/** TMMAPI-0111: why change-offer refuses the offer. `null` on the wire while `selectable`. */
export type OfferNotSelectableReason = 'OFFER_CLOSED' | 'RATE_CARD_NOT_ACTIVE';

/**
 * `OfferView` — `@JsonInclude(NON_NULL)`. `resellerRateCardId` is required: the reseller card
 * version the offer was derived from. The admin view always carries the AI terms.
 */
export interface OfferView {
  id: number;
  tenantId: number;
  /** Present when the offer is under a reseller agreement (TMMAPI-0075). */
  resellerAgreementId: number;
  resellerRateCardId: number;
  status: OfferStatus;
  current: boolean;
  /**
   * TMMAPI-0119: whether change-offer accepts this offer. Always present.
   * The change-offer picker lists only `true`.
   */
  selectable: boolean;
  /**
   * TMMAPI-0111: why it isn't selectable. Always present; `null` while `selectable` is true.
   */
  notSelectableReason: OfferNotSelectableReason | null;
  currency: string;
  interval: BillingInterval;
  /** Typed, not rendered (annual offers). */
  monthlyEquivalentMinor?: number;
  savingsBp?: number;
  subscriberCount: number;
  baseRetailMinor: number;
  seatBands: BandView[];
  connectedAccountBands: BandView[];
  aiMarkupBp: number;
  aiFirstPurchaseMinor: number;
  aiRechargeTriggerMinor: number;
  aiRechargeAmountMinor: number;
  aiMonthlyCreditMinor: number;
  aiCreditPlatformShareBp: number;
  trialDaysNewSubscriber: number;
  trialDaysGuestConversion: number;
  graceDaysAfterEnd: number;
  createdAt: string;
  closedAt?: string;
}

export interface OfferList {
  offers: OfferView[];
}

/**
 * `PreviewExample` (TMMAPI-0097) — one subscriber's month at the card's prices, before any
 * promotion: `guests` guests, `connectedAccounts` connected accounts and AI worth
 * `aiAtOurPriceMinor` at our AI price. Every field always present.
 */
export interface PreviewExample {
  currency: string;
  guests: number;
  connectedAccounts: number;
  aiAtOurPriceMinor: number;
  baseMinor: number;
  seatsMinor: number;
  connectedMinor: number;
  aiMinor: number;
  subtotalMinor: number;
  totalMinor: number;
}

/**
 * Rate cards (TMMAPI-0131, the one card since TMMAPI-0154 / MM-D-136; TMMPDM-0091 re-pins to
 * `b1f55fab`, blob `ce5273d5c827`). Views have no `NON_NULL`: nullable fields are always sent and
 * may be JSON `null`. Writes omit absent fields (`CustomerRateCardVersionWrite` is `NON_NULL`).
 * `annualBaseMinor: 0` stores no annual price. There is no version GET and no retire route.
 * TMMAPI-0154: a version holds our cost, wholesale and retail for every line. Our cost
 * (`baseCostMinor`, the bands' `cost*`) and our AI markup (`aiWholesaleMarkupBp`) are product-admin
 * only; the console sends them only to `/v1/admin/customer-rate-cards/**`. Our annual cost isn't
 * stored (the monthly cost × 12, the server's). The deprecated version fields (grace, the recharge
 * count; TMMAPI-0153) are never shown or sent; the tax fields are gone (TMMAPI-0156).
 */
export type CustomerRateCardStatus = 'DRAFT' | 'PUBLISHED' | 'RETIRED';

export interface CustomerRateCardVersionView {
  id: number;
  versionNo: number;
  status: CustomerRateCardStatus;
  version: number;
  current: boolean;
  baseMinor: number;
  baseWholesaleMinor: number;
  baseCostMinor: number;
  annualBaseMinor: number | null;
  /** 0 without an annual base. */
  annualBaseWholesaleMinor: number;
  trialDaysNewSubscriber: number;
  trialDaysGuestConversion: number;
  /** Our markup over the provider's AI cost (bp). */
  aiWholesaleMarkupBp: number;
  /** The retail markup over our AI wholesale (bp; was `aiMarkupBp`). */
  aiRetailMarkupBp: number;
  aiFirstPurchaseMinor: number;
  aiRechargeTriggerMinor: number;
  aiRechargeAmountMinor: number;
  /** The monthly credit at the customer's price (a write may set it by its cost to us instead). */
  aiMonthlyCreditMinor: number;
  aiCreditPlatformShareBp: number;
  seatBands: AdminBandView[];
  connectedAccountBands: AdminBandView[];
  subscriberCount: number;
  createdAt: string;
  activatedAt: string | null;
  closedAt: string | null;
  /**
   * TMMAPI-0155: every publish rule the version breaks now (the 409 `RATE_CARD_INVALID` list); empty
   * when it would publish. Not in the view's `required:` list, so absent reads as none. `rule` is
   * the server's text and is never shown (TMM-B3): the console words a violation by its `field`.
   */
  violations: RateCardVersionViolation[];
}

/** `RateCardVersionViolation` (TMMAPI-0155): both keys required. */
export interface RateCardVersionViolation {
  field: string;
  rule: string;
}

export interface CustomerRateCardView {
  id: number;
  name: string;
  currency: string;
  status: CustomerRateCardStatus;
  version: number;
  currentVersionId: number | null;
  grants: number[];
  adoptingResellers: number[];
  versions: CustomerRateCardVersionView[];
  createdAt: string;
}

export interface CustomerRateCardList {
  rateCards: CustomerRateCardView[];
}

/**
 * `CustomerCardControlsCreate` (TMMAPI-0155): the card's first controls row, in force at its
 * creation. Partial: each absent field (or the whole object) takes today's default. A field the
 * service doesn't use is 400 `VALIDATION_FAILED` (`controls.<field>`), never ignored.
 */
export interface CustomerCardControlsCreate {
  maxAiSpendMinor?: number;
  aiDailyCap?: number;
  aiMaxInflight?: number;
  aiMaxAutoRecharges30d?: number;
  graceDaysAfterEnd?: number;
  affiliateRecurringMaxBp?: number;
  affiliateBountyMaxMinor?: number;
  affiliateMilestoneMaxMinor?: number;
  affiliateCoolOffMaxDays?: number;
}

/**
 * Create requires `name`, `currency` and `baseMinor`. The server inserts version 1 as DRAFT.
 * TMMAPI-0155: a retail price above 0 comes with its wholesale (else 400 naming the wholesale
 * field); there is no tax on create (MM-D-137; no card tax at all since TMMAPI-0156) and an unknown
 * field is 400.
 */
export interface CustomerRateCardCreateRequest {
  name: string;
  currency: string;
  baseMinor: number;
  baseWholesaleMinor?: number;
  baseCostMinor?: number;
  annualBaseMinor?: number;
  annualBaseWholesaleMinor?: number;
  trialDaysNewSubscriber?: number;
  trialDaysGuestConversion?: number;
  aiWholesaleMarkupBp?: number;
  aiRetailMarkupBp?: number;
  aiFirstPurchaseMinor?: number;
  aiRechargeTriggerMinor?: number;
  aiRechargeAmountMinor?: number;
  aiMonthlyCreditMinor?: number;
  aiCreditPlatformShareBp?: number;
  seatBands?: BandInput[];
  connectedAccountBands?: BandInput[];
  controls?: CustomerCardControlsCreate;
}

/** Name any time. Currency only while no version has been published (`currentVersionId` null). */
export interface CustomerRateCardPatchRequest {
  name?: string;
  currency?: string;
}

/**
 * Absent fields stay. `version` is the version row's optimistic version; `0` is sent.
 * `aiMonthlyCreditCostMinor` (TMMAPI-0154) sets the credit by its cost to us; the server converts it
 * with the markups after this write. Sending it with `aiMonthlyCreditMinor` is 400.
 */
export interface CustomerRateCardVersionWrite {
  name?: string;
  baseMinor?: number;
  baseWholesaleMinor?: number;
  baseCostMinor?: number;
  annualBaseMinor?: number;
  annualBaseWholesaleMinor?: number;
  trialDaysNewSubscriber?: number;
  trialDaysGuestConversion?: number;
  aiWholesaleMarkupBp?: number;
  aiRetailMarkupBp?: number;
  aiFirstPurchaseMinor?: number;
  aiRechargeTriggerMinor?: number;
  aiRechargeAmountMinor?: number;
  aiMonthlyCreditMinor?: number;
  aiMonthlyCreditCostMinor?: number;
  aiCreditPlatformShareBp?: number;
  seatBands?: BandInput[];
  connectedAccountBands?: BandInput[];
  version?: number;
}

export interface CustomerRateCardGrantRequest {
  resellerId: number;
}

export interface CustomerRateCardMoveResult {
  moved: number;
  alreadyCurrent: number;
  failed: number;
}

/**
 * Adopt's answer (the reseller-facing shape: retail bands, no cost, no wholesale markup).
 * `example` and the nullable amounts are always sent and may be null. Typed, not rendered.
 */
export interface GrantedCustomerRateCardView {
  id: number;
  name: string;
  currency: string;
  adopted: boolean;
  currentVersionId: number | null;
  baseMinor: number;
  annualBaseMinor: number | null;
  trialDaysNewSubscriber: number;
  trialDaysGuestConversion: number;
  aiRetailMarkupBp: number;
  aiFirstPurchaseMinor: number;
  aiRechargeTriggerMinor: number;
  aiRechargeAmountMinor: number;
  aiMonthlyCreditMinor: number;
  aiCreditPlatformShareBp: number;
  seatBands: BandView[];
  connectedAccountBands: BandView[];
  marginMinor: number | null;
  example: PreviewExample | null;
}

/** `WorksheetRequest` (TMMAPI-0154): all four required; guests and connections 0–50. */
export type WorksheetMode = 'MONTHLY' | 'ANNUAL';

export interface WorksheetRequest {
  mode: WorksheetMode;
  guests: number;
  connections: number;
  /** AI used per month at the customer's price, minor units, at least 0. */
  aiUsedMinor: number;
}

export type WorksheetLineKind =
  | 'BASE'
  | 'GUESTS'
  | 'CONNECTIONS'
  | 'SUBSCRIPTION_PROCESSING'
  | 'AI_PAID'
  | 'AI_CREDIT'
  | 'RECHARGE_PROCESSING'
  | 'TOTAL';

/** One line, per month, signed minor units: costs are negative. Every key required. */
export interface WorksheetLine {
  line: WorksheetLineKind;
  customerPaysMinor: number;
  resellerCostsMinor: number;
  resellerProfitMinor: number;
  ourCostMinor: number;
  ourProfitMinor: number;
}

/** One charge in the steps: `kind` is BASE, ADD_ONS or RECHARGE (a string on the YAML). */
export interface WorksheetCharge {
  kind: string;
  grossMinor: number;
  feeMinor: number;
  resellerShareMinor: number;
  platformShareMinor: number;
  perYear: number;
}

export interface WorksheetSteps {
  subscriptionChargesPerYear: number;
  charges: WorksheetCharge[];
  /** The currency's processing rate in force now; both `null` when none is set. */
  feePercentBp: number | null;
  feeFixedMinor: number | null;
  recharges: number;
  /** The monthly credit's provider cost: what the credit costs us. */
  creditCostMinor: number;
}

export interface WorksheetTerms {
  currency: string;
  includedGuests: number;
  includedConnections: number;
  aiMonthlyCreditMinor: number;
}

export type WorksheetBillLineKind = 'BASE' | 'GUESTS' | 'CONNECTIONS' | 'AI_USAGE' | 'AI_CREDIT';

/**
 * `WorksheetBillLine` (TMMAPI-0155, item 22a): `NON_NULL`, so `quantity`, `unitPriceMinor` and
 * `flatMinor` are absent when unset, never `null`. `amountMinor` is signed (`AI_CREDIT` negative).
 * A band line states the band the count falls in, its unit price and flat per month (the flat
 * omitted when 0); its amount is × 12 on ANNUAL.
 */
export interface WorksheetBillLine {
  kind: WorksheetBillLineKind;
  quantity?: number;
  unitPriceMinor?: number;
  flatMinor?: number;
  amountMinor: number;
}

/**
 * `WorksheetBill` (TMMAPI-0155): the customer's bill at customer prices; every key required. Lines
 * in the order BASE, GUESTS, CONNECTIONS, AI_USAGE, AI_CREDIT. The subtotal is per month on
 * `MONTH`, per year on `YEAR`; `aiNetMinor` is per month on both.
 */
export interface WorksheetBill {
  period: 'MONTH' | 'YEAR';
  lines: WorksheetBillLine[];
  subscriptionSubtotalMinor: number;
  aiNetMinor: number;
}

/** `POST /v1/admin/customer-rate-cards/{id}/versions/{versionId}/worksheet` — any version. */
export interface AdminWorksheet {
  versionId: number;
  mode: WorksheetMode;
  lines: WorksheetLine[];
  totals: WorksheetLine;
  steps: WorksheetSteps;
  terms: WorksheetTerms;
  bill: WorksheetBill;
  /**
   * TMMAPI-0155: each profit as a percent of what the customer pays, over the totals, in bp (may be
   * negative); required, `null` when the customer pays 0. Shown as sent (TMMPDM-0091).
   */
  ourProfitBp: number | null;
  resellerProfitBp: number | null;
}

/** `ProcessingFeeRateRow` (TMMAPI-0154): every key required. No id; rates are never withdrawn. */
export interface ProcessingFeeRateRow {
  percentBp: number;
  fixedMinor: number;
  effectiveFrom: string;
  createdAt: string;
  createdBy: string;
}

/** `GET`/`PUT /v1/admin/billing/processing-fees/{currency}`: `current` is `null` before the first rate. */
export interface ProcessingFeeRatesView {
  currency: string;
  current: ProcessingFeeRateRow | null;
  scheduled: ProcessingFeeRateRow[];
  history: ProcessingFeeRateRow[];
}

/** `percentBp` 0–10000, `fixedMinor` ≥ 0; `effectiveFrom` absent means now. */
export interface ProcessingFeeRateWrite {
  percentBp: number;
  fixedMinor: number;
  effectiveFrom?: string;
}

/**
 * TMMAPI-0153 live settings (YAML at `ade6f131`). One effective-dated row: the current row is the
 * latest with `effectiveFrom ≤ now`; only a future row can be withdrawn, softly. `effectiveFrom` /
 * `createdAt` are RFC 3339 UTC instants. Every key is required; the four nullable ones are sent as
 * `null` when unset.
 */
export interface SettingRowMeta {
  id: number;
  effectiveFrom: string;
  createdAt: string;
  /** The creating admin's display name, else their email ('migration' on a seeded row). */
  createdBy: string;
  seeded: boolean;
  note: string | null;
  withdrawnAt: string | null;
  withdrawnBy: string | null;
  withdrawNote: string | null;
}

/** `GET …/controls`, `/v1/admin/ai-controls`: all three keys required, `current` non-null. */
export interface SettingsEnvelope<Row> {
  current: Row;
  scheduled: Row[];
  history: Row[];
}

export interface CardControlsRow extends SettingRowMeta {
  maxAiSpendMinor: number;
  aiDailyCap: number;
  aiMaxInflight: number;
  aiMaxAutoRecharges30d: number;
  graceDaysAfterEnd: number;
  /** TMMAPI-0154: the affiliate maximums, live per card (were our wholesale card's). */
  affiliateRecurringMaxBp: number;
  affiliateBountyMaxMinor: number;
  affiliateMilestoneMaxMinor: number;
  affiliateCoolOffMaxDays: number;
}

export interface CardControlsEnvelope extends SettingsEnvelope<CardControlsRow> {
  cardId: number;
  /** The card's currency, for `maxAiSpendMinor` and the affiliate money maximums. */
  currency: string;
  /** True while a non-USD card still has its seeded row. The banner reads this alone. */
  reviewSuggested: boolean;
}

export interface PlatformAiControlsRow extends SettingRowMeta {
  domainSetupResellerDaily: number;
  domainSetupPlatformDaily: number;
}

export type PlatformAiControlsEnvelope = SettingsEnvelope<PlatformAiControlsRow>;

/** POST body: a full row, `effectiveFrom` absent for now, an optional `note` (≤ 500). */
export type SettingWrite = Record<string, unknown> & { effectiveFrom?: string; note?: string };

/** TMMAPI-0104 (MM-D-106): a commission plan's mode — one phase from month 1, or up to six. */
export type CommissionPlanMode = 'SIMPLE' | 'ADVANCED';
/** `BASE`: the subscription price only. `ALL`: base, seats, connected accounts and AI (never tax). */
export type CommissionAppliesTo = 'BASE' | 'ALL';
/** `STOP`: nothing is earned after the affiliate ends. `HONOR`: existing referrals keep earning. */
export type CommissionAfterEnd = 'STOP' | 'HONOR';

/**
 * One phase of a plan's schedule (`PhaseView` / `PhaseInput`, NON_NULL): `rateBp` for the referral's
 * paid months `fromMonth..toMonth`; `toMonth` absent = open-ended (lifetime).
 */
export interface CommissionPhase {
  fromMonth: number;
  toMonth?: number;
  rateBp: number;
}

/**
 * One milestone bonus (TMMAPI-0105): `amountMinor` the first time qualified referrals reach
 * `qualifiedReferrals`. Both fields are always present on a view row and on a write row.
 */
export interface CommissionPlanMilestone {
  qualifiedReferrals: number;
  amountMinor: number;
}

/**
 * `CommissionPlanView` (TMMAPI-0104) — `@JsonInclude(NON_NULL)`: primitives, `name`, `status`,
 * `mode`, `currency`, `appliesTo`, `afterEnd`, `phases` and `createdAt` are always present;
 * `noncompliantSince`, `activatedAt` and `closedAt` are absent until they happen. `noncompliant` is
 * the server's verdict (an agreement change put it over a limit: it can't be assigned to more
 * affiliates; affiliates on it keep it).
 * TMMAPI-0105: the five ADVANCED components are always serialized (`ALWAYS`), `null` when unset.
 * A Simple plan has them all `null`. `bountyOnPayment` is `null` when there is no bounty.
 */
export interface CommissionPlanView {
  id: number;
  name: string;
  status: RateCardStatus;
  noncompliant: boolean;
  noncompliantSince?: string;
  mode: CommissionPlanMode;
  currency: string;
  appliesTo: CommissionAppliesTo;
  coolOffDays: number;
  afterEnd: CommissionAfterEnd;
  phases: CommissionPhase[];
  createdAt: string;
  activatedAt?: string;
  closedAt?: string;
  bountyMinor: number | null;
  bountyOnPayment: number | null;
  milestones: CommissionPlanMilestone[] | null;
  perReferralCapMinor: number | null;
  perAffiliateMonthCapMinor: number | null;
  /**
   * TMMAPI-0114: Java `long`, always written. `editableFields` lists `name` in any state; `mode`
   * and the other terms only while DRAFT.
   */
  version: number;
  editableFields: string[];
}

/** `GET /v1/admin/resellers/{resellerId}/commission-plans`. */
export interface CommissionPlanList {
  commissionPlans: CommissionPlanView[];
}

/**
 * `CommissionPlanWriteRequest` (TMMAPI-0104) — every field optional (Java `@Nullable`): `POST`
 * starts from the default draft, `PATCH` keeps what the body leaves out; `phases` replaces the whole
 * schedule. No currency — it is the agreement card's.
 */
export interface CommissionPlanWriteRequest {
  name?: string;
  mode?: CommissionPlanMode;
  appliesTo?: CommissionAppliesTo;
  coolOffDays?: number;
  afterEnd?: CommissionAfterEnd;
  phases?: CommissionPhase[];
  /**
   * TMMAPI-0105, ADVANCED only. `0` removes a bounty or a cap. `milestones`, when present, replaces
   * the whole list; `[]` removes them. `bountyOnPayment` is 1–12 and 1 when absent. A Simple plan
   * that still has any of them is refused (`400`, "only an ADVANCED plan has it"); the server does
   * not clear them on a mode change.
   */
  bountyMinor?: number;
  bountyOnPayment?: number;
  milestones?: CommissionPlanMilestone[];
  perReferralCapMinor?: number;
  perAffiliateMonthCapMinor?: number;
  /** TMMAPI-0114: the view's `version`. `0` is a real version and is sent. */
  version?: number;
}

/** `POST …/commission-plans/preview` — a plan body plus the reseller's own card to price it at. */
export interface CommissionPlanPreviewRequest extends CommissionPlanWriteRequest {
  rateCardId?: number;
}

/**
 * One paid month of the preview's example. The 0104 fields are always present.
 * TMMAPI-0105: `bountyMinor` is always present and `null` except in the bounty's payment;
 * `capped` is always present — the server's mark that a cap cut that month. Milestones are not
 * in the example.
 */
export interface CommissionPlanPreviewMonth {
  month: number;
  collectedOn: string;
  rateBp: number;
  commissionMinor: number;
  marginBeforeMinor: number;
  marginAfterMinor: number;
  payableOn: string;
  bountyMinor: number | null;
  capped: boolean;
}

/** One subscriber at `retailMinor` a month on `rateCardId`, for paid months 1–24. */
export interface CommissionPlanPreviewExample {
  rateCardId: number;
  currency: string;
  retailMinor: number;
  coolOffDays: number;
  months: CommissionPlanPreviewMonth[];
}

/**
 * The plan dry run; writes nothing. `fields` names each failing field and its limit (always
 * present, empty when valid; `rateCardId` when none was sent); `example` is absent while the
 * schedule is invalid or no card was sent.
 */
export interface CommissionPlanPreview {
  valid: boolean;
  fields: Record<string, string>;
  example?: CommissionPlanPreviewExample;
}

/**
 * `CommissionPlanRef` (TMMAPI-0104 / 0106) — the plan an agreement names. Always the four fields;
 * no currency and no `noncompliantSince` (those live on the plan, not this ref).
 */
export interface CommissionPlanRef {
  id: number;
  name: string;
  status: RateCardStatus;
  noncompliant: boolean;
}

/**
 * One currency of referred revenue and commission. Never summed with another currency.
 * TMMAPI-0105: `commission*` stays recurring commission only. Bounties, milestones and clawbacks
 * are on `GET …/affiliates/{id}/earnings`, not here.
 */
export interface AffiliatePerformance {
  currency: string;
  referredRevenue30dMinor: number;
  referredRevenueToDateMinor: number;
  commission30dMinor: number;
  commissionToDateMinor: number;
}

/**
 * One month of `AffiliateEarnings` (TMMAPI-0105). Every amount is a positive magnitude, always
 * present. `month` is `YYYY-MM` (when it was earned). The server orders months newest first.
 * `recurringMinor` + `bountyMinor` + `milestoneMinor` equals `pendingMinor` + `payableMinor`
 * (non-voided). `voidedMinor` is a refund inside the cool-off; `clawedBackMinor` is one after it;
 * `recoveredMinor` is what statements recovered of a clawback. No total is published.
 */
export interface AffiliateEarningsMonth {
  month: string;
  recurringMinor: number;
  pendingMinor: number;
  payableMinor: number;
  voidedMinor: number;
  bountyMinor: number;
  milestoneMinor: number;
  clawedBackMinor: number;
  recoveredMinor: number;
}

/**
 * `GET /v1/admin/tenants/{slug}/affiliates/{id}/earnings`. One currency — the tenant's, which is
 * the affiliate statements' currency. A month with nothing earned has no row.
 */
export interface AffiliateEarnings {
  currency: string;
  months: AffiliateEarningsMonth[];
}

export type AffiliateStatus = 'APPLIED' | 'ACTIVE' | 'PAUSED' | 'ENDED';
export const AFFILIATE_STATUSES: readonly AffiliateStatus[] = [
  'APPLIED',
  'ACTIVE',
  'PAUSED',
  'ENDED',
];

/**
 * `AffiliateAgreementView` (TMMAPI-0106, NON_NULL). `endedAt` is absent while the agreement is in
 * force. `commissionPlan` is always present and never `null` (TMMAPI-0125). TMMAPI-0161:
 * `taxIdStatus` is nullable and not `required` (null for a partner without a pay-api payee).
 */
export interface AffiliateAgreementView {
  id: number;
  commissionPlan: CommissionPlanRef;
  effectiveFrom: string;
  endedAt?: string;
  minPayoutMinor: number;
  payoutCadence: PayoutCadence;
  payoutMethod: PayoutMethod;
  taxDocsStatus: TaxDocsStatus;
  taxIdStatus?: TaxIdStatus | null;
}

/** `AffiliateAgreementHistory`. `inForce` is always present and `null` when none is in force. */
export interface AffiliateAgreementHistory {
  inForce: AffiliateAgreementView | null;
  history: AffiliateAgreementView[];
}

/**
 * `AffiliateListRow` (TMMAPI-0106). `userId` and `agreement` are absent until set. There is no
 * approval or end date on this row. `payoutsHeldForReview` is always present — never inferred
 * from `status`. The deprecated all-currency commission integer is intentionally not mapped.
 */
export interface AffiliateListRow {
  id: number;
  userId?: number;
  email: string;
  displayName: string;
  status: AffiliateStatus;
  appliedAt: string;
  agreement?: AffiliateAgreementView;
  codeCount: number;
  referredActive: number;
  payoutsHeldForReview: boolean;
  performance: AffiliatePerformance[];
}

export interface AffiliateList {
  affiliates: AffiliateListRow[];
}

export interface AffiliateListQuery {
  status?: AffiliateStatus;
}

/** Present only while an end for cause holds the affiliate's unpaid statements. */
export interface AffiliateReviewHold {
  since: string;
  reason: string;
  /** The product admin's saas-auth user id. */
  by: string;
}

export interface AffiliateReferralsSummary {
  active: number;
  total: number;
}

/** `WeeklySignups`: `weekStart` is a calendar date. */
export interface WeeklySignups {
  weekStart: string;
  signups: number;
}

export type AffiliateCodeStatus = 'ACTIVE' | 'PAUSED';
export const AFFILIATE_CODE_STATUSES: readonly AffiliateCodeStatus[] = ['ACTIVE', 'PAUSED'];

/** `AffiliateCodeView`. `label` is absent when the code has none. */
export interface AffiliateCodeView {
  id: number;
  code: string;
  label?: string;
  link: string;
  status: AffiliateCodeStatus;
  createdAt: string;
}

export interface AffiliateCodeList {
  codes: AffiliateCodeView[];
}

/**
 * `AffiliateDetail`. The same unset rule as the list row, plus `approvedAt`, `endedAt` and
 * `reviewHold` (absent unless held). `codes`, `performance`, `referrals` and `weeklySignups`
 * are always present.
 */
export interface AffiliateDetail {
  id: number;
  userId?: number;
  email: string;
  displayName: string;
  status: AffiliateStatus;
  appliedAt: string;
  approvedAt?: string;
  endedAt?: string;
  agreement?: AffiliateAgreementView;
  codes: AffiliateCodeView[];
  referrals: AffiliateReferralsSummary;
  weeklySignups: WeeklySignups[];
  performance: AffiliatePerformance[];
  reviewHold?: AffiliateReviewHold;
}

export type AffiliateReferralStatus = 'ACTIVE' | 'ENDED' | 'SUPERSEDED' | 'VOIDED';
export const AFFILIATE_REFERRAL_STATUSES: readonly AffiliateReferralStatus[] = [
  'ACTIVE',
  'ENDED',
  'SUPERSEDED',
  'VOIDED',
];
export type AffiliateReferralSource = 'SUBSCRIBE' | 'ROUTE';

/**
 * `AffiliateReferralRow` (NON_NULL). `subscriberDisplayName`, `email`, `offerName`,
 * `commissionPlanId`, `firstPaidOn` and `supersededAt` are absent when unset — never null.
 * `currency` is the subscription's, and `thisPeriodCommissionMinor` is in it.
 */
export interface AffiliateReferralRow {
  attributionId: number;
  subscriberDisplayName?: string;
  email?: string;
  offerName?: string;
  since: string;
  firstPaidOn?: string;
  status: AffiliateReferralStatus;
  commissionPlanId?: number;
  thisPeriodCommissionMinor: number;
  currency: string;
  source: AffiliateReferralSource;
  supersededAt?: string;
}

export interface AffiliateReferralList {
  referrals: AffiliateReferralRow[];
}

export interface AffiliateReferralQuery {
  status?: AffiliateReferralStatus;
}

/** `{reason}` for end and release-hold: 3–500 characters. */
export interface AffiliateCauseRequest {
  reason: string;
}

/**
 * `ResellerAffiliateRow` (TMMAPI-0106). `userId` is absent until set. `commissionPlan` is always
 * present and `null` while no agreement naming a plan is in force. No review-hold flag — the
 * tenant list's chip does not belong on this row.
 */
export interface ResellerAffiliateRow {
  tenantSlug: string;
  id: number;
  userId?: number;
  email: string;
  displayName: string;
  status: AffiliateStatus;
  appliedAt: string;
  commissionPlan: CommissionPlanRef | null;
  codeCount: number;
  referredActive: number;
  performance: AffiliatePerformance[];
}

export interface ResellerAffiliateList {
  affiliates: ResellerAffiliateRow[];
}

export type PromotionKind = 'OFFER' | 'TRIAL_DAYS' | 'PERCENT_OFF_VARIABLE' | 'AMOUNT_OFF_VARIABLE';
export type PromotionStatus = 'ACTIVE' | 'PAUSED' | 'ENDED';

export interface PromotionView {
  id: number;
  tenantId: number;
  code: string;
  name: string;
  kind: PromotionKind;
  status: PromotionStatus;
  currency?: string;
  amountMinor?: number;
  percentBp?: number;
  trialDays?: number;
  statements?: number;
  retailOfferId?: number;
  newSubscribersOnly: boolean;
  maxRedemptions?: number;
  redemptionCount: number;
  validFrom: string;
  validUntil?: string;
  createdAt: string;
  createdByAdmin: string;
}

export interface PromotionList {
  promotions: PromotionView[];
}

export type SubscriptionOrigin = 'SELF' | 'ADMIN' | 'COMP';

/** YAML `AdminCancelRequest.mode` pattern — verified `at_period_end|immediate`. */
export type CancelMode = 'at_period_end' | 'immediate';

export type ChargeStatus =
  'NONE' | 'PENDING' | 'PAID' | 'ACTION_REQUIRED' | 'FAILED' | 'ATTENTION' | 'WAIVED';
export const CHARGE_STATUSES: readonly ChargeStatus[] = [
  'NONE',
  'PENDING',
  'PAID',
  'ACTION_REQUIRED',
  'FAILED',
  'ATTENTION',
  'WAIVED',
];

export type StatementLineKind = 'RENEWAL' | 'SEAT' | 'AI' | 'PROMOTION' | 'TAX' | 'CONNECTED';

export type PendingSubscriptionStatus = 'PENDING' | 'COMPLETED' | 'EXPIRED' | 'CANCELLED';

export type SeatStatus = 'ACTIVE' | 'ENDING' | 'ENDED';

export type EntitlementKind = 'SUBSCRIBER' | 'GUEST_SEAT';

/** YAML `Comp` — `until` is date-time when present. */
export interface Comp {
  until?: string;
}

export interface AdminSubscribeRequest {
  email: string;
  trialDays?: number;
  comp?: Comp;
  cardToken?: string;
  idempotencyKey?: string;
}

export interface AdminSubscribeResponse {
  subscription?: AdminSubscriptionRow;
  pending?: PendingSubscriptionRow;
}

export interface AdminCancelRequest {
  mode: CancelMode;
}

export interface AdminCompRequest {
  until?: string;
}

export interface ApplyPromotionRequest {
  code: string;
}

export interface AdminChangeOfferRequest {
  retailOfferId: number;
}

export interface AiSuspensionRequest {
  suspended: boolean;
  reason: string;
}

export interface AiSuspensionResponse {
  subscriptionId: number;
  userId: number;
  suspended: boolean;
  aiSuspendedAt?: string;
}

export interface CancelResponse {
  status: string;
  endsAt: string;
}

/**
 * YAML `AppliedPromotion` (tmm-api 0124), the promotion applied to a subscription. Every key is
 * always present: the terms of the other kinds are `null`, never absent. `statementsRemaining` is
 * `null` for a variable kind that runs until ended, and always `null` for `OFFER`. A `TRIAL_DAYS`
 * code never shows as applied. There is no end date: the code's own `validUntil` limits new
 * redemptions only.
 */
export interface AppliedPromotion {
  promotionId: number;
  code: string;
  name: string;
  kind: PromotionKind;
  appliedAt: string;
  statementsRemaining: number | null;
  /** `PERCENT_OFF_VARIABLE`: the discount in basis points. */
  percentBp: number | null;
  /** `AMOUNT_OFF_VARIABLE`: the discount per statement, in minor units of `currency`. */
  amountMinor: number | null;
  currency: string | null;
  /** `OFFER`: the promotional retail offer. */
  retailOfferId: number | null;
}

export interface AdminSubscriptionRow {
  id: number;
  userId: number;
  email: string;
  displayName?: string;
  status: string;
  origin: SubscriptionOrigin;
  interval: BillingInterval;
  /** Typed, not rendered. */
  pendingChange?: PendingChange;
  retailOfferId: number;
  trialEndsOn?: string;
  compedUntil?: string;
  currentPeriodStart?: string;
  currentPeriodEnd?: string;
  nextBillingOn?: string;
  cardBrand?: string;
  maskedCard?: string;
  payApiSubscriptionId?: string;
  reconciledAt?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
  /** YAML `required`: always present on every route that answers the row, `null` when none. */
  appliedPromotion: AppliedPromotion | null;
}

export interface PendingChange {
  interval: BillingInterval;
  effectiveOn: string;
}

export interface PendingSubscriptionRow {
  id: number;
  email: string;
  status: PendingSubscriptionStatus;
  retailOfferId?: number;
  trialDays?: number;
  /** YAML: boolean, not a Comp object. */
  comp: boolean;
  compedUntil?: string;
  saasAuthInvitationId?: string;
  createdByAdmin: string;
  createdAt: string;
  expiresAt: string;
  completedAt?: string;
}

export interface AdminSubscriptionList {
  subscriptions: AdminSubscriptionRow[];
  pending: PendingSubscriptionRow[];
}

/** YAML `EntitlementItem` at pin `bddf764`. */
export interface EntitlementItem {
  kind: EntitlementKind;
  status: SeatStatus;
  startsAt: string;
  endsAt?: string;
  sponsorDisplayName?: string;
}

/** pay-api `ClientAction` — every field present-and-`null` when unset (no NON_NULL). */
export interface ClientAction {
  type: string | null;
  clientSecret: string | null;
  connectedAccountId: string | null;
  intent: string | null;
}

/** YAML `SubscriptionView` (pay-api stored state). */
export interface SubscriptionView {
  subscriptionId: string;
  status: string;
  planMappingId: number;
  contactRef: string;
  verticalRef: string;
  createdAt: string;
  nextBillingOn: string | null;
  pauseEffectiveOn: string | null;
  cardBrand: string | null;
  maskedCard: string | null;
  pspSubscriptionId: string | null;
  /** Typed, not rendered. Java `@Nullable` without NON_NULL — present-and-`null`. */
  clientAction: ClientAction | null;
}

export interface StatementLineView {
  kind: StatementLineKind;
  description: string;
  quantity?: number;
  unitMicro?: number;
  amountMinor: number;
  reference?: string;
}

export interface StatementView {
  id: number;
  currency: string;
  periodStart: string;
  periodEnd: string;
  chargeStatus: ChargeStatus;
  renewalMinor?: number;
  seats: number;
  seatsMinor: number;
  /** TMMAPI-0156: pay-api's tax on the paid charge (0 before, and when it returned none). */
  taxMinor: number;
  totalMinor: number;
  attempts: number;
  lastAttemptAt?: string;
  lastError?: string;
  payApiChargeRef?: string;
  lines: StatementLineView[];
  createdAt: string;
  updatedAt: string;
}

export interface AdminSubscriptionDetail {
  subscription: AdminSubscriptionRow;
  entitlements: EntitlementItem[];
  statements: StatementView[];
  payApi?: SubscriptionView;
}

export interface AdminStatementList {
  statements: StatementView[];
}

export interface AdminSeatRow {
  entitlementId: number;
  userId: number;
  guestDisplayName?: string;
  sponsorUserId: number;
  sponsorDisplayName?: string;
  status: SeatStatus;
  since: string;
  endsAt?: string;
}

export interface AdminSeatList {
  seats: AdminSeatRow[];
}

export interface AdminWaiveRequest {
  reason: string;
}

export interface SubscriptionListQuery {
  status?: string | undefined;
  email?: string | undefined;
}

export interface StatementListQuery {
  period?: string | undefined;
  status?: string | undefined;
}

export interface SeatListQuery {
  sponsorUserId?: number | undefined;
}

export type RevenueLineKind = 'BASE' | 'SEAT' | 'CONNECTED' | 'AI' | 'TAX';
export type PayeeKind = 'RESELLER' | 'AFFILIATE';
/** TMMAPI-0099: `CHARGED` — a negative settlement, charged to the reseller's card, never paid. */
export type PayoutStatus = 'PENDING' | 'CARRIED' | 'PAID' | 'CHARGED' | 'RETAINED';
export const PAYOUT_STATUSES: readonly PayoutStatus[] = [
  'PENDING',
  'CARRIED',
  'PAID',
  'CHARGED',
  'RETAINED',
];
/**
 * TMMAPI-0098: `HOLD_RESELLER_UNPAID` — a reseller charge unpaid 7 days holds its payouts.
 * TMMAPI-0106: `HOLD_AFFILIATE_REVIEW` — an end for cause holds the affiliate's unpaid statements.
 */
export type PayoutHold =
  | 'HOLD_TAX_DOCS'
  | 'HOLD_STRIPE_CONNECT'
  | 'HOLD_TRANSFER_CURRENCY'
  | 'HOLD_TRANSFER_CAP'
  | 'HOLD_RESELLER_UNPAID'
  | 'HOLD_AFFILIATE_REVIEW';
/**
 * TMMAPI-0126: `CANCELLED` is a retry that never reached pay-api, superseded by a manual record or a
 * new retry (`failureCode` `SUPERSEDED_BY_MANUAL` / `SUPERSEDED_BY_RETRY`). Terminal; no money moved.
 */
export type PayoutTransferStatus =
  'REQUESTED' | 'PENDING' | 'SUCCEEDED' | 'FAILED' | 'REJECTED' | 'CANCELLED';

export interface RevenueQuery {
  /** ISO date, inclusive. Always sent. */
  from: string;
  /** ISO date, inclusive. Always sent. */
  to: string;
  resellerId?: number;
}

/**
 * One currency's fleet revenue totals (never summed across currencies). TMMAPI-0099:
 * `resellerMarginMinor` (retail − wholesale, may be negative; equals `upliftMinor`). With no
 * revenue share, `platformShareMinor` is the wholesale and `tenantShareMinor` the reseller's margin
 * less its affiliates' commission — the console shows margin and reseller net, not uplift/platform.
 */
export interface CurrencyRevenueTotals {
  currency: string;
  retailMinor: number;
  wholesaleMinor: number;
  upliftMinor: number;
  tenantShareMinor: number;
  platformShareMinor: number;
  taxMinor: number;
  refundsMinor: number;
  resellerMarginMinor: number;
}

export interface RevenueLineTotals {
  retailMinor: number;
  wholesaleMinor: number;
  upliftMinor: number;
  tenantShareMinor: number;
  platformShareMinor: number;
  taxMinor: number;
  refundsMinor: number;
  resellerMarginMinor: number;
}

export interface KindTotals {
  line: RevenueLineKind;
  retailMinor: number;
  wholesaleMinor: number;
  upliftMinor: number;
  tenantShareMinor: number;
  platformShareMinor: number;
  resellerMarginMinor: number;
}

export interface TenantRevenue {
  tenantId: number;
  slug: string;
  totals: RevenueLineTotals;
  byLineKind: KindTotals[];
}

export interface RevenueReport {
  from: string;
  to: string;
  tenants: TenantRevenue[];
  totals: CurrencyRevenueTotals[];
}

/**
 * `PayoutStatementLineView` (was `RevenueEventView` before this pin). `kind` is a free string on
 * the YAML: a ledger line's `RENEWAL` | `VARIABLE` | `REFUND`, or a statement-only
 * `AFFILIATE_COMMISSION` / `ADDON_FEE` line — which has no `line` and may have no `id`.
 * TMMAPI-0105: an affiliate statement also carries event lines whose `kind` is `BOUNTY`,
 * `MILESTONE` or `CLAWBACK` (a `RECOVERY` is the reseller's, not a line here). `line` is absent;
 * the amount is `affiliateCommissionMinor`.
 */
export interface PayoutStatementLineView {
  id?: number;
  kind: string;
  line?: RevenueLineKind;
  collectedAt?: string;
  currency: string;
  retailMinor: number;
  wholesaleMinor: number;
  upliftMinor: number;
  tenantShareMinor: number;
  platformShareMinor: number;
  affiliateCommissionMinor: number;
  revShareBpApplied: number;
  payApiPaymentRef?: string;
  /**
   * TMMAPI-0099, Java `@Nullable Long`, NON_NULL: a ledger line's margin (retail − wholesale, may
   * be negative), absent on a statement-only line; an `AI` line's price at our AI price (micro),
   * absent on any other line or where nothing prices it. Never provider cost.
   */
  resellerMarginMinor?: number;
  aiAtOurPriceMicro?: number;
}

/**
 * TMMAPI-0099: one line kind of a monthly settlement, summed over its ledger rows. NON_NULL:
 * `aiAtOurPriceMicro` is present only on `AI`, and only when something prices it.
 */
export interface SettlementLineSummary {
  line: RevenueLineKind;
  retailMinor: number;
  wholesaleMinor: number;
  resellerMarginMinor: number;
  affiliateCommissionMinor: number;
  aiAtOurPriceMicro?: number;
}

/** TMMAPI-0099: a `CHARGED` settlement's `STATEMENT_DEFICIT` charge on the reseller's card. */
export interface SettlementCharge {
  id: number;
  amountMinor: number;
  status: ResellerChargeStatus;
}

/** Published settlement components; never inferred from whole-row net. */
export interface SettlementPart {
  status: PayoutStatus;
  netMinor: number;
  payableMinor: number;
  note: string;
}

export interface PayoutStatementView {
  retainedPart?: SettlementPart;
  normalPart?: SettlementPart;
  note?: string;
  id: number;
  tenantId: number;
  tenantSlug: string;
  payeeKind: PayeeKind;
  payeeId: number;
  /** The payee's name when the server sends one. Shown on the run sheet and in Release hold. */
  payeeName?: string;
  cadence: PayoutCadence;
  periodStart: string;
  periodEnd: string;
  currency: string;
  grossMinor: number;
  wholesaleMinor: number;
  upliftMinor: number;
  tenantShareMinor: number;
  platformShareMinor: number;
  carriedInMinor: number;
  payableMinor: number;
  payoutMethod: PayoutMethod;
  payoutStatus: PayoutStatus;
  hold?: PayoutHold;
  payoutAt?: string;
  payoutRef?: string;
  closedAt: string;
  /** Typed, not rendered: the Stripe Connect transfer state (TMMAPI Connect payouts). */
  connectStatus?: string;
  transferStatus?: PayoutTransferStatus;
  failureCode?: string;
  transferRef?: string;
  attempt?: number;
  /** Java `@Nullable`, NON_NULL: present on the per-tenant list and a record response, ABSENT on
   *  the fleet run sheet (`GET /v1/admin/payouts`). */
  lines?: PayoutStatementLineView[];
  /**
   * TMMAPI-0099, Java `@Nullable`, NON_NULL — a reseller's per-reseller statement (its monthly
   * settlement) only; absent on an affiliate's statement and a tenant-payee one from before 0076.
   * Margin (Σ retail − wholesale, may be negative), its affiliates' commission, and the net.
   */
  resellerMarginMinor?: number;
  /** Recurring commission only (TMMAPI-0105). Bounties and milestones are the fields below. */
  affiliateCommissionMinor?: number;
  /**
   * The month's net, which decides the payout or the charge: margin − recurring commission −
   * bounties − milestones + recovered. The server's figure; never recomputed here.
   */
  netMinor?: number;
  /**
   * TMMAPI-0105, Java `@Nullable Long`, NON_NULL — present on a reseller settlement (including 0)
   * and absent on an affiliate statement. Positive magnitudes: bounties and milestones are debits,
   * recovered is a credit.
   */
  affiliateBountiesMinor?: number;
  affiliateMilestonesMinor?: number;
  affiliateRecoveredMinor?: number;
  /** The `STATEMENT_DEFICIT` charge of a `CHARGED` settlement; absent otherwise (or not found). */
  charge?: SettlementCharge;
  /** Per line kind, present with `lines` only (absent on the run sheet). */
  byLine?: SettlementLineSummary[];
}

export interface UnattributedRevenue {
  currency: string;
  rows: number;
  retailMinor: number;
  tenantShareMinor: number;
}

export interface RunSheet {
  payouts: PayoutStatementView[];
  unattributed: UnattributedRevenue[];
}

export interface PayoutStatementList {
  payoutStatements: PayoutStatementView[];
}

/** `GET …/resellers/{id}/settlements` filters (TMMAPI-0099): ISO dates and a currency, each optional. */
export interface SettlementQuery {
  from?: string | undefined;
  to?: string | undefined;
  currency?: string | undefined;
}

export type ResellerChargeKind = 'MINIMUM_SHORTFALL' | 'STATEMENT_DEFICIT';
export const RESELLER_CHARGE_KINDS: readonly ResellerChargeKind[] = [
  'MINIMUM_SHORTFALL',
  'STATEMENT_DEFICIT',
];
export type ResellerChargeStatus =
  'PENDING' | 'REQUESTED' | 'SUCCEEDED' | 'FAILED' | 'REQUIRES_ACTION';
export const RESELLER_CHARGE_STATUSES: readonly ResellerChargeStatus[] = [
  'PENDING',
  'REQUESTED',
  'SUCCEEDED',
  'FAILED',
  'REQUIRES_ACTION',
];

/**
 * `ResellerCharge` (TMMAPI-0098, `ChargeView`) — NON_NULL: `failureCode` and `nextRetryAt` are
 * absent when unset (`nextRetryAt` also once the 7 daily retries are over); the rest always.
 */
export interface ResellerCharge {
  id: number;
  kind: ResellerChargeKind;
  periodStart: string;
  currency: string;
  amountMinor: number;
  status: ResellerChargeStatus;
  attempt: number;
  failureCode?: string;
  nextRetryAt?: string;
  holdsPayouts: boolean;
  /**
   * TMMAPI-0109 (Java primitive, always written): whether the product admin's retry accepts this
   * charge. Retry is offered on this alone; any other charge answers 409
   * `RESELLER_CHARGE_NOT_RETRYABLE`.
   */
  retryable: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ResellerChargeList {
  charges: ResellerCharge[];
}

export type ResellerBillingCardStatus = 'ACTIVE' | 'EXPIRED' | 'requires_action';
export const RESELLER_BILLING_CARD_STATUSES: readonly ResellerBillingCardStatus[] = [
  'ACTIVE',
  'EXPIRED',
  'requires_action',
];

/**
 * `ResellerBillingCard` (TMMAPI-0098, `CardView`) — NON_NULL: the display fields are absent on a
 * `requires_action` card. The admin read answers the JSON `null` body when there is no card.
 * `clientAction` (it carries a Stripe client secret) is deliberately NOT typed: the console never
 * reads or renders it (TMMPDM-0037).
 */
export interface ResellerBillingCard {
  brand?: string;
  last4?: string;
  expMonth?: number;
  expYear?: number;
  status: ResellerBillingCardStatus;
}

export type ResellerNoticeKind =
  | 'LAUNCH_REMINDER'
  | 'PROBATION_STARTED'
  | 'PROBATION_MONTHLY'
  | 'CHARGE_FAILED'
  | 'CHARGE_ACTION_REQUIRED'
  | 'DEACTIVATED'
  | 'RECOVERED';
export const RESELLER_NOTICE_KINDS: readonly ResellerNoticeKind[] = [
  'LAUNCH_REMINDER',
  'PROBATION_STARTED',
  'PROBATION_MONTHLY',
  'CHARGE_FAILED',
  'CHARGE_ACTION_REQUIRED',
  'DEACTIVATED',
  'RECOVERED',
];
export type ResellerNoticeStatus = 'PENDING' | 'SENDING' | 'SENT' | 'SKIPPED' | 'FAILED';
export const RESELLER_NOTICE_STATUSES: readonly ResellerNoticeStatus[] = [
  'PENDING',
  'SENDING',
  'SENT',
  'SKIPPED',
  'FAILED',
];

/** `ResellerNoticeCharge` (TMMAPI-0100) — all fields always present. */
export interface ResellerNoticeCharge {
  id: number;
  kind: ResellerChargeKind;
  currency: string;
  amountMinor: number;
  status: ResellerChargeStatus;
  holdOn: string;
}

/**
 * `ResellerNoticeFacts` (TMMAPI-0100) — NON_NULL: each key is present only on the kinds whose email
 * states it. Money is minor units in `currency` (the charges carry their own).
 */
export interface ResellerNoticeFacts {
  month?: string;
  currency?: string;
  shortfallMinor?: number;
  probationMonths?: number;
  targetMinor?: number;
  earnedMinor?: number;
  stillNeededMinor?: number;
  deactivationOn?: string;
  launchOn?: string;
  charges?: ResellerNoticeCharge[];
  toResellerId?: number;
  tenantsMoved?: number;
}

/**
 * `ResellerNoticeView` (TMMAPI-0100) — NON_NULL: `recipientCount` and `sentAt` are absent until
 * sent. The recipients themselves are never on the wire and never typed.
 */
export interface ResellerNoticeView {
  id: number;
  kind: ResellerNoticeKind;
  periodOn: string;
  status: ResellerNoticeStatus;
  recipientCount?: number;
  createdAt: string;
  sentAt?: string;
  facts: ResellerNoticeFacts;
}

export interface ResellerNoticeList {
  notices: ResellerNoticeView[];
}

/**
 * `amountMinor` must equal the statement's `payableMinor` unless
 * `override: true` with a `reason` (TMMAPI-0033 delivery; both audited). Override covers only
 * that amount difference: a statement on hold (`HOLD_TAX_DOCS`, `HOLD_RESELLER_UNPAID`) is
 * refused with 409 `PAYOUT_ON_HOLD` whatever `override` is.
 */
export interface PayoutRequest {
  amountMinor: number;
  paidAt: string;
  ref: string;
  override?: boolean;
  reason?: string;
}

export interface AiModelPriceRow {
  id: number;
  model: string;
  currency: string;
  effectiveFrom: string;
  inForce: boolean;
  inputPerMtokMicro: number;
  outputPerMtokMicro: number;
  cacheReadPerMtokMicro: number;
  cacheWritePerMtokMicro: number;
  createdAt: string;
  /** TMMAPI-0164: required, never null. */
  createdByAdmin: string;
  /** TMMAPI-0165: required, never null. */
  createdBy: string;
  /**
   * TMMAPI-0165. Omitted when unset (`NON_NULL`); never null. A withdrawn row has `withdrawnAt`
   * set; absent is not withdrawn.
   */
  note?: string;
  withdrawnAt?: string;
  withdrawnBy?: string;
  withdrawNote?: string;
}

export interface AiModelPriceListResponse {
  asOf: string;
  prices: AiModelPriceRow[];
}

/**
 * YAML (TMMAPI-0167): model, currency and the four micros are required; `effectiveFrom` and `note`
 * are optional and not nullable. Now omits `effectiveFrom` (absence means now). `note` is sent
 * only when non-empty.
 */
export interface AiModelPriceCreateRequest {
  model: string;
  currency: string;
  inputPerMtokMicro: number;
  outputPerMtokMicro: number;
  cacheReadPerMtokMicro: number;
  cacheWritePerMtokMicro: number;
  effectiveFrom?: string;
  note?: string;
}

/**
 * YAML `AiModelAssignmentRow` (`Row` before TMMAPI-0167; `GET`/`POST
 * /v1/admin/ai-model-assignments`). Not a 0153 settings row: no `seeded`. `note` and the
 * withdrawal fields are omitted when unset, never null.
 */
export interface AiModelAssignmentRow {
  id: number;
  tier: string;
  model: string;
  effectiveFrom: string;
  createdAt: string;
  createdBy: string;
  /** TMMAPI-0171: required. `LOW`…`MAX`, or a value this build does not name (shown as sent). */
  effort: string;
  note?: string;
  withdrawnAt?: string;
  withdrawnBy?: string;
  withdrawNote?: string;
}

/**
 * YAML `AiModelAssignmentTier` (`TierView` before TMMAPI-0167). `current` is required and null
 * when the tier has no model. The other five keys are required and non-null. The missing banner
 * reads `missingCurrencies` alone.
 */
export interface AiModelAssignmentTier {
  /** `FAST`, `DEEP`, or a code this build does not name. */
  tier: string;
  current: AiModelAssignmentRow | null;
  scheduled: AiModelAssignmentRow[];
  history: AiModelAssignmentRow[];
  pricedCurrencies: string[];
  missingCurrencies: string[];
}

/**
 * YAML `AiModelAssignmentModelsByTier` (TMMAPI-0171): each tier's active catalogue models. Both
 * keys are required.
 */
export interface AiModelAssignmentModelsByTier {
  FAST: string[];
  DEEP: string[];
}

/**
 * YAML `AiModelAssignmentList` (`ListResponse` before TMMAPI-0167) for
 * `GET /v1/admin/ai-model-assignments`. All three keys are required. TMMAPI-0171: `modelsByTier`
 * replaces `supportedModels`.
 */
export interface AiModelAssignmentsView {
  modelsByTier: AiModelAssignmentModelsByTier;
  currenciesSold: string[];
  tiers: AiModelAssignmentTier[];
}

/** The assignment efforts (TMMAPI-0171, MM-D-145), lowest first. */
export const AI_EFFORTS = ['LOW', 'MEDIUM', 'HIGH', 'XHIGH', 'MAX'] as const;
export type AiEffort = (typeof AI_EFFORTS)[number];

/**
 * YAML `AiModelAssignmentCreateRequest` (`CreateRequest` before TMMAPI-0167;
 * `POST /v1/admin/ai-model-assignments`). `effectiveFrom` and `note` are optional and not
 * nullable. Now omits `effectiveFrom` (absence means now). An empty note omits `note`.
 */
export interface AiModelAssignmentWrite {
  tier: string;
  model: string;
  /** TMMAPI-0171: optional on the wire (the tier's default); this console always sends it. */
  effort?: AiEffort;
  effectiveFrom?: string;
  note?: string;
}

/**
 * YAML `AiModelCatalogRow` (TMMAPI-0171; `GET/POST /v1/admin/ai-models`, `PATCH /{id}`,
 * `POST /{id}/verify`). The seven required keys are never null; the rest are omitted when unset,
 * never null. `providerCheckedAt` is absent on a row carried over from 0165 until it is verified.
 * `usedBy` names the tiers (`FAST`, `DEEP`) whose current or scheduled assignment names the model.
 */
export interface AiModelCatalogRow {
  id: number;
  modelId: string;
  fast: boolean;
  deep: boolean;
  createdBy: string;
  createdAt: string;
  usedBy: string[];
  displayName?: string;
  providerCheckedAt?: string;
  note?: string;
  retiredAt?: string;
  retiredBy?: string;
  retireNote?: string;
  /**
   * TMMAPI-0172: the efforts Anthropic says the model takes, from the last lookup. Absent when
   * unknown (not verified since 0172): an assignment then takes only the tier's default.
   */
  efforts?: AiEffort[];
  /** TMMAPI-0172: Anthropic's lifecycle (`active`, `deprecated`, `retired`); absent when unknown. */
  lifecycle?: string;
  /** TMMAPI-0172: when Anthropic retires the model (date-time); absent when none. */
  retiresAt?: string;
  /**
   * TMMAPI-0174: whether Anthropic says the model takes structured outputs, from the last lookup.
   * Absent when unknown (not verified since 0174); `false` means it can't be assigned.
   */
  structuredOutputs?: boolean;
}

/** YAML `AiModelCatalogList`: active models first, then retired. */
export interface AiModelCatalogList {
  models: AiModelCatalogRow[];
}

/** YAML `AiModelCatalogAddRequest`: `modelId`, `fast` and `deep` required; `note` at most 500. */
export interface AiModelCatalogAddRequest {
  modelId: string;
  fast: boolean;
  deep: boolean;
  note?: string;
}

/**
 * YAML `AiModelCatalogPatchRequest`: every key optional (omit to leave it unchanged). `note` is
 * nullable on the YAML: `null` clears it.
 */
export interface AiModelCatalogPatchRequest {
  fast?: boolean;
  deep?: boolean;
  note?: string | null;
}

export interface ReconcileDivergence {
  subscriptionId: number;
  payApiSubscriptionId?: string;
  fields: Record<string, string>;
}

export interface SkippedFeedEvent {
  seq: number;
  eventType: string;
  attempts: number;
  exceptionClass?: string;
  appliedAt: string;
}

/** `FeedStall` (TMMAPI-0126): both keys `required`; `seq` is int64, `since` a date-time instant. */
export interface FeedStall {
  seq: number;
  since: string;
}

export interface BillingAttention {
  attentionStatements: StatementView[];
  divergences: ReconcileDivergence[];
  skippedEvents: SkippedFeedEvent[];
  /**
   * The pay-api feed event a lock conflict keeps giving back, once stalled for over an hour
   * (TMMAPI-0126). `required` and `oneOf` [`FeedStall`, null]: always present, `null` otherwise.
   */
  feedStalled: FeedStall | null;
  /** Typed, not rendered. */
  staleJobs: string[];
  /**
   * 0159 (MM-D-139): the pay-api feed events kept `UNHANDLED`, counted by type. `required`; empty
   * when there are none.
   */
  unhandledEvents: UnhandledFeedEvents[];
  /**
   * 0159 (PAYAPI-0162): pay-api's `sku_review_required` items for tmm-api's products. `required` and
   * `[array, null]`: `null` when pay-api couldn't be read, empty when nothing awaits.
   */
  skuReviewRequired: SkuReview[] | null;
  /**
   * 0159: charges pay-api refused with `TAX_CLASSIFICATION_REQUIRED` in the last 30 days. `required`;
   * empty when there are none.
   */
  taxClassificationFailures: TaxClassificationFailure[];
  /** 0159: disputes lost again after a win (the Operator adjusts the margin). Typed, not rendered. */
  reLostDisputes: ReLostDispute[];
}

/** `UnhandledFeedEvents` (0159): all three keys `required`; `count` is int64, `oldest` a date-time. */
export interface UnhandledFeedEvents {
  eventType: string;
  count: number;
  oldest: string;
}

/** `SkuReview` (0159): all three keys `required`; `detail` and `since` are `[type, null]`. */
export interface SkuReview {
  sku: string;
  detail: string | null;
  since: string | null;
}

/**
 * `TaxClassificationFailure` (0159): every key `required`; `tenantId` and `resellerId` are
 * `[integer, null]`. `chargeKind` is a plain string (`WALLET_CHARGE`, `ADDON_CHARGE`,
 * `RESELLER_CHARGE` at the pin).
 */
export interface TaxClassificationFailure {
  chargeId: number;
  chargeKind: string;
  failedAt: string;
  tenantId: number | null;
  resellerId: number | null;
}

/** `ReLostDispute` (0159): every key `required`; `closedAt` and `tenantId` are `[type, null]`. Not rendered. */
export interface ReLostDispute {
  disputeId: string;
  paymentId: string;
  kind: string;
  lastSeq: number;
  closedAt: string | null;
  tenantId: number | null;
}

/** `SkuDeclaration.outcome` (0159): `CLASSIFIED` is pay-api's 409 `SKU_CLASSIFIED`, left alone. */
export type SkuDeclarationOutcome = 'DECLARED' | 'CLASSIFIED' | 'FAILED';

/** `SkuDeclaration` (0159): every key `required`; `payApiCode` is `[string, null]`. */
export interface SkuDeclaration {
  sku: string;
  audience: string;
  outcome: SkuDeclarationOutcome;
  payApiCode: string | null;
}

/** `POST /v1/admin/billing/skus/declare` answers 200 with one entry per product (`skus` `required`). */
export interface SkuDeclarations {
  skus: SkuDeclaration[];
}

/**
 * `POST /v1/admin/billing/payees/backfill` (TMMAPI-0161, audited `PAYEES_BACKFILLED`, idempotent)
 * answers 200 with seven fields, all `required`. The six counts are integers; `failed` is a list
 * of strings (the partners the run couldn't store), not a count. `kindUnavailable` counts
 * `AFFILIATE:` payees whose kind pay-api couldn't correct yet (run again once it has).
 */
export interface PayeeBackfillResult {
  matched: number;
  stored: number;
  kindFixed: number;
  kindUnavailable: number;
  policySet: number;
  unmatched: number;
  failed: string[];
}

/** `ParkedFeedEventView.reasonCode` (TMMAPI-0121): why a pay-api feed event was parked. */
export type ParkedReasonCode =
  | 'REFUND_EXCEEDS_PAYMENT'
  | 'REFUND_CURRENCY_MISMATCH'
  | 'REFUND_PARENT_MISSING'
  | 'REFUND_PARENT_NOT_MIRRORED'
  | 'REFUND_CURRENCY_MISSING'
  | 'REFUND_FIELDS_MISSING'
  | 'DISPUTE_FIELDS_MISSING'
  | 'HANDLER_FAILED';
export const PARKED_REASON_CODES: readonly ParkedReasonCode[] = [
  'REFUND_EXCEEDS_PAYMENT',
  'REFUND_CURRENCY_MISMATCH',
  'REFUND_PARENT_MISSING',
  'REFUND_PARENT_NOT_MIRRORED',
  'REFUND_CURRENCY_MISSING',
  'REFUND_FIELDS_MISSING',
  'DISPUTE_FIELDS_MISSING',
  'HANDLER_FAILED',
];

/** `ParkedFeedEventView.resolution`: how a person resolved it; `null` while unresolved. */
export type ParkedResolution = 'REAPPLIED' | 'DISMISSED';
export const PARKED_RESOLUTIONS: readonly ParkedResolution[] = ['REAPPLIED', 'DISMISSED'];

/**
 * `GET /v1/admin/billing/parked-events` row (TMMAPI-0121). Every key is always present (YAML
 * `required`); the nullable ones are present-and-`null`, never absent. There is no amount.
 * `reasonCode` is never `null` (TMMAPI-0125); `resolution` and the `resolved*` keys are
 * `null` while unresolved; `exceptionClass` is `null` once re-applied. The console reads `reasonCode`,
 * `resolution` and the rest one at a time: it never combines two of them into a decision.
 */
export interface ParkedFeedEventView {
  seq: number;
  /** A pay-api event type ("payment.refunded"); the YAML says string, so any value can arrive. */
  eventType: string;
  reasonCode: ParkedReasonCode;
  attempts: number;
  /** The handler exception's simple name. Copied for support, never shown (TMM-B3). */
  exceptionClass: string | null;
  parkedAt: string;
  resolution: ParkedResolution | null;
  resolvedAt: string | null;
  /** The resolving admin's audit label. */
  resolvedBy: string | null;
  resolutionNote: string | null;
  /** The envelope's paymentId (for a refund, the refund's own id). */
  paymentId: string | null;
  subscriptionId: string | null;
}

export interface ParkedFeedEventPage {
  events: ParkedFeedEventView[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

/** `POST …/parked-events/{seq}/reapply` and `…/dismiss`: `note` is 3–500 characters (trimmed server-side). */
export interface ParkedEventNoteRequest {
  note: string;
}

export interface ParkedEventsQuery {
  resolved: boolean;
  /** 0-based, as the server counts. */
  page: number;
  size: number;
}

export type DeletionStatus = 'PENDING' | 'CANCELLED' | 'ERASING' | 'ERASED' | 'FAILED';

export type AiFeature =
  | 'IMPORT_MAPPING'
  | 'CATEGORY_SUGGESTION'
  | 'ENVELOPE_ANALYSIS'
  | 'MEETING_SUMMARY'
  | 'MATCH_SUGGESTION'
  | 'DOMAIN_SETUP'
  | 'PAYEE_SUGGESTION'
  // TMMPDM-0110: in the YAML's closed `FeatureUsageRow.feature` enum (since TMMAPI-0160); labelled now.
  | 'PAYEE_PATTERN'
  // TMMPDM-0109 (TMMAPI-0181 U2 item E, U4 item 23; spec-typed): My Financial Assistant and the
  // Support assistant. Each has its own tmm-api environment switch, off by default; the switch's
  // state is not served, so the console only labels the usage.
  | 'FINANCIAL_ASSISTANT'
  | 'SUPPORT_ASSISTANT';

export interface AdminDeletionRow {
  id: number;
  userId: number;
  displayName?: string;
  requestedBy: string;
  requestedAt: string;
  coolingOffUntil: string;
  status: DeletionStatus;
  erasedAt?: string;
  attempts: number;
  /**
   * The last attempt's error (a pay-api status and code, or the failing step's), cleared when the
   * request is erased. Optional, never `null` (not `required`, no `nullable` in the YAML). Free text:
   * copy-only for support, never shown and never parsed (the words come from `lastErrorCode`).
   */
  lastError?: string;
  /**
   * TMMAPI-0160 U4: `lastError` as a closed code, written beside it by the same step and present
   * whenever `lastError` is. Optional, never `null`. `UNKNOWN` is a request that failed before the
   * code was recorded.
   */
  lastErrorCode?: DeletionErrorCode;
}

export type DeletionErrorCode =
  | 'ASSOCIATION_HOLD'
  | 'PAY_API_UNAVAILABLE'
  | 'PAY_API_REFUSED'
  | 'ERASURE_IN_PROGRESS'
  | 'IDEMPOTENCY_CONFLICT'
  | 'STEP_FAILED'
  | 'UNKNOWN';
export const DELETION_ERROR_CODES: readonly DeletionErrorCode[] = [
  'ASSOCIATION_HOLD',
  'PAY_API_UNAVAILABLE',
  'PAY_API_REFUSED',
  'ERASURE_IN_PROGRESS',
  'IDEMPOTENCY_CONFLICT',
  'STEP_FAILED',
  'UNKNOWN',
];

export interface AdminDeletionList {
  requests: AdminDeletionRow[];
}

export interface AdminDeletionRequest {
  userId: number;
  reason: string;
}

export interface DeletionRequestView {
  id: number;
  requestedAt: string;
  coolingOffUntil: string;
  status: DeletionStatus;
  erasedAt?: string;
}

/**
 * tmm-api erase-now (0157, 0158): 200 `{ erased: true, erasedAt }` (also when already erased), or 202
 * `{ erased: false, retrying }`. `retrying: true`: the request is `ERASING` and the job finishes it.
 * `retrying: false`: it has just gone `FAILED`, the job won't finish it, and calling erase-now again
 * retries it (0158). A `FAILED` request is retried, not 404.
 */
export interface ImmediateErasureView {
  erased: boolean;
  erasedAt?: string;
  retrying?: boolean;
}

export interface FeatureUsageRow {
  feature: AiFeature;
  requests: number;
  failed: number;
  inputTokens: number;
  outputTokens: number;
  cacheReadTokens: number;
  cacheWriteTokens: number;
  totalTokens: number;
  costMicro?: number;
  currency: string;
  estimatedChargeMinor: number;
  /**
   * TMMAPI-0109: our AI price for the usage — provider cost × (1 + our markup). NON_NULL: absent
   * where no offer prices the person. On a product-wide feature row (TMMAPI-0111) it is present
   * only when every contributing person is priced.
   */
  atOurPriceMicro?: number;
  /**
   * TMMAPI-0111: always present on a product-wide feature row, absent on a person's feature row.
   * `true` means some contributor isn't priced, and `atOurPriceMicro` is then absent. The screen
   * shows "Partial" from this flag alone.
   */
  atOurPricePartial?: boolean;
}

export interface PersonUsageRow {
  userId: number;
  email?: string;
  displayName?: string;
  requests: number;
  failed: number;
  totalTokens: number;
  costMicro?: number;
  currency: string;
  /** TMMAPI-0151: the person's AI wallet usage in the window (USAGE debits), in `currency`. */
  estimatedChargeMinor: number;
  features: FeatureUsageRow[];
  /**
   * TMMAPI-0109: our AI price for the usage — provider cost × (1 + our markup). NON_NULL: absent
   * where no offer prices the person; a product-wide feature row carries the sum of its people's.
   */
  atOurPriceMicro?: number;
  /** TMMAPI-0151: the person's AI wallet over the window. Absent for a person with no wallet. */
  wallet?: AiWalletPeriodView;
  /**
   * TMMAPI-0153 section G item 32: true when the person has a live subscription (the credit's
   * precondition). Add AI credit… is offered from this alone. Absent on the reseller's report only.
   */
  aiCreditAvailable?: boolean;
  /** Item 33: the product admin's AI suspension (`users.ai_suspended_at`). Nullable. */
  aiSuspendedAt?: string | null;
}

/**
 * YAML `AiWalletPeriodView` (TMMAPI-0151): each figure as the server sent it, never summed or
 * derived. `currency` (0153 item 32) is the wallet's, which can differ from the row's operating
 * `currency`.
 */
export interface AiWalletPeriodView {
  purchasesMinor: number;
  rechargesMinor: number;
  topUpsMinor: number;
  monthlyCreditsMinor: number;
  adminCreditsMinor: number;
  usageMinor: number;
  balanceMinor: number;
  currency: string;
}

/**
 * `POST …/people/{userId}/ai-credit` (TMMAPI-0152). `amountMinor` 1–1,000,000,000; `reason`
 * 1–255; `idempotencyKey` ≤ 64, one per dialog opening. A replayed key answers the first credit.
 */
export interface AdminAiCreditRequest {
  amountMinor: number;
  reason: string;
  idempotencyKey: string;
}

/** The credit, in the person's wallet currency (0153 item 32). */
export interface AdminAiCreditResponse {
  entryId: number;
  amountMinor: number;
  balanceMinor: number;
  currency: string;
}

/**
 * `GET /v1/admin/ai-cost-reconciliation` (TMMAPI-0152; one row per UTC day per currency and the
 * two provider-rejected counts are 0153 section G item 31). Every count and micro amount is that
 * row's `currency`. `mustBeZeroBreached` is the row's verdict. Never summed across rows.
 */
export interface AiCostReconciliationView {
  day: string;
  /** Item 31: required on the YAML at `ade6f131`. */
  currency: string;
  reconciledAt: string;
  mustBeZeroBreached: boolean;
  requestsSent: number;
  settledActual: number;
  settledAtHold: number;
  holdExpiredCharged: number;
  /** Item 31. */
  providerRejected: number;
  /** Item 31: 401/403, must be zero. */
  providerRejectedAuth: number;
  releasedAfterSend: number;
  costOverHold: number;
  sentUnsettled: number;
  /** TMMAPI-0171: answers that stopped at `max_tokens`. A plain count, not must-be-zero. */
  truncated: number;
  /** TMMAPI-0171: answers the provider refused. A plain count, not must-be-zero. */
  refused: number;
  customerProviderCostMicro: number;
  customerUsageMicro: number;
  platformCostMicro: number;
}

export interface AiCostReconciliationList {
  days: AiCostReconciliationView[];
}

/** UTC dates, `from ≤ to`, at most 366 days. */
export interface AiCostReconciliationQuery {
  from: string;
  to: string;
}

/** YAML also carries `platformAbsorbedMicro` (TMMAPI-0042); never summed or shown as a tile. */
export interface UsageReport {
  from: string;
  to: string;
  requests: number;
  failed: number;
  totalTokens: number;
  features: FeatureUsageRow[];
  people: PersonUsageRow[];
  platformAbsorbedMicro?: number;
}

export interface AiUsageQuery {
  /** ISO date-time instant (local-day start). Always sent. */
  from: string;
  /** ISO date-time instant (local-day end). Always sent. */
  to: string;
  userId?: number | undefined;
}

export interface AdminInvitationRequest {
  email: string;
}

export interface AdminInvitationResponse {
  invitationId: number;
  email: string;
  emailSent: boolean;
}

/* ---------------------------------------------------------------- resellers (TMMPDM-0017)
 * `/v1/admin/resellers/**` passes saas-auth's DTOs through UNWRAPPED (no `{success,data}`
 * envelope). Moved from `../saas/types.ts` with TMMPDM-0015's names and null/optional rule
 * (saas-auth @ `9a08cf8`): only `defaultBrandId`, `createdAt` and `updatedAt` (TMMPDM-0069: not `required` in the 0119 YAML) and tmm's list-only `standing` are optional;
 * every other `@Nullable` is present-and-`null`. YAML names: `ResellerDto` = `AdminReseller`, `ResellerPage` =
 * `AdminResellerPage`, `CreateResellerRequest` = `AdminResellerCreateRequest`,
 * `UpdateResellerRequest` = `AdminResellerPatchRequest`, `ResellerGhlIntegrationDto` =
 * `AdminResellerGhl`, `UpsertResellerGhlRequest` = `AdminResellerGhlRequest`.
 */

export type ResellerStatus = 'ACTIVE' | 'SUSPENDED';

/** TMMAPI-0115: all keys serialized, including nullable inner fields. */
export interface TenantPair {
  slug: string;
  name: string;
  status: string;
  sellable: boolean;
  sellableReason: SellableReason | null;
}

export interface ResellerPair {
  id: number;
  name: string | null;
  status: string | null;
}

export interface ResellerDto {
  platformOwned: boolean;
  /** TMMAPI-0119: whether marking this partner as House is accepted. */
  platformOwnedSettable: boolean;
  tenant: TenantPair | null;
  tenantCreatable: boolean;
  tenantCreatableReason: 'HAS_TENANT' | 'RESELLER_SUSPENDED' | 'RESELLER_DEACTIVATED' | null;
  id: number;
  slug: string;
  name: string;
  status: ResellerStatus;
  /** Optional on passthrough reads; null on the TMMAPI-0119 standing-filtered list. */
  defaultBrandId?: number | null;
  /**
   * NON_NULL — present only on `GET /v1/admin/resellers` rows (tmm-api 0077: "the reseller list
   * sets it, and every other route omits it"); omitted on get, create, patch. The detail page
   * reads `GET …/{id}/standing` instead (TMMPDM-0023).
   */
  standing?: ResellerStandingSummary;
  tenantCount: number;
  /** TMMPDM-0069: not `required` in the YAML at `b8547ce`; null on the TMMAPI-0119 standing-filtered list. */
  createdAt?: string | null;
  updatedAt?: string | null;
  /**
   * TMMAPI-0114: `name` and `status`, always attached on the product-admin path. No `version`.
   * Status stays the Suspend / Reactivate flows; the details dialog edits `name` only.
   */
  editableFields?: string[];
}

/** `GET /v1/admin/resellers` — saas-auth's page shape: read `content` (unlike `TenantList`). */
export interface ResellerPage {
  content: ResellerDto[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface ResellerListQuery {
  page?: number | undefined;
  /** Default 50, capped (clamped) at 200 server-side. */
  size?: number | undefined;
  /** Case-insensitive contains on slug and name. */
  q?: string | undefined;
  status?: ResellerStatus | undefined;
  /** TMMAPI-0119: comma-separated states, filtered before server paging. */
  standing?: string | undefined;
}

export interface CreateResellerRequest {
  slug: string;
  name: string;
}

/** PATCH body — an omitted field is unchanged. */
export interface UpdateResellerRequest {
  platformOwned?: boolean;
  name?: string;
  status?: ResellerStatus;
}

/** The masked read. `tokenSuffix` is `"…" + the last four characters`; never the token. */
export interface ResellerGhlIntegrationDto {
  id: number | null;
  resellerId: number | null;
  locationId: string | null;
  tokenSet: boolean;
  tokenSuffix: string | null;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

/** PUT body — a blank/omitted token keeps the stored one; `active` defaults to true server-side. */
export interface UpsertResellerGhlRequest {
  locationId?: string;
  privateIntegrationToken?: string;
  active?: boolean;
}

/* ---------------------------------------------------------------- whitelabel domain + GHL diagnose (TMMPDM-0018)
 * `/v1/admin/tenants/{slug}/whitelabel-domain…` and `/v1/admin/resellers/{id}/ghl-integration/diagnose`
 * pass saas-auth's DTOs through (springdoc types their members as `JsonNode`), so the field shapes
 * are read from saas-auth's Java @ `8208402` (`dto/saasadmin/`). Every `@Nullable` is
 * present-and-`null`. `dnsRecords` is the one exception: saas-auth omits it (NON_NULL) and tmm-api's
 * re-serializing record writes it back as `null`, so it is typed both optional and nullable and read
 * with `!= null`. YAML names: `WhitelabelDomainDto` = `AdminWhitelabelDomain`,
 * `WhitelabelTemplateDto` = `AdminWhitelabelTemplate`, `WhitelabelTemplateHost` =
 * `AdminWhitelabelTemplateHost`, `PutWhitelabelDomainRequest` = `AdminWhitelabelDomainRequest`,
 * `WhitelabelHostEntryRequest` = `AdminWhitelabelHostRequest`, `WhitelabelVerifyResponse` =
 * `AdminWhitelabelVerify`, `ResellerGhlIntegrationDiagnosisDto` = `AdminResellerGhlDiagnosis`.
 */

/** DRAFT: entered, not routable. ACTIVE: every hostname verified. The server's claim, never derived. */
export type WhitelabelDomainState = 'DRAFT' | 'ACTIVE';

/** saas-auth `HostnameType` @ `8208402` — all six values (a whitelabel PUT rejects `API`). */
export type HostnameType = 'APP' | 'LOGIN' | 'AUTH' | 'API' | 'ASSET' | 'BRAND';

export interface WhitelabelHostnameDto {
  id: number;
  /** Derived from the hostname minus the domain; never stored. */
  prefix: string;
  hostname: string;
  hostnameType: HostnameType;
  appId: number | null;
  appSlug: string | null;
  dnsVerified: boolean;
  dnsVerifiedAt: string | null;
}

/** One CNAME the customer creates. `type` is always `CNAME` today; typed as the wire's string. */
export interface DnsRecordDto {
  host: string;
  type: string;
  target: string;
  dnsVerified: boolean;
}

/** `configured: false` is the normal "not set up" state (not a 404): nulls and an empty list. */
export interface WhitelabelDomainDto {
  tenantId: number;
  configured: boolean;
  domain: string | null;
  state: WhitelabelDomainState | null;
  /** saas-auth ISO local date-time; `null` while DRAFT or not configured. */
  activatedAt: string | null;
  hostnames: WhitelabelHostnameDto[];
  /** Whether the environment has an expected DNS target, so `dnsRecords` can be composed. */
  dnsConfigured: boolean;
  dnsRecords?: DnsRecordDto[] | null;
}

export interface WhitelabelTemplateHost {
  prefix: string;
  hostnameType: HostnameType;
  appId: number | null;
  appSlug: string | null;
  /** `required` | `optional` on the Java's schema; typed as the wire's string. */
  note: string;
}

/** `GET …/whitelabel-domain/template` — a pure derivation; nothing is written. */
export interface WhitelabelTemplateDto {
  hosts: WhitelabelTemplateHost[];
}

/** TMMAPI-0167: `appId` is optional and not nullable; a host with no app omits it. */
export interface WhitelabelHostEntryRequest {
  prefix: string;
  hostnameType: HostnameType;
  appId?: number;
}

/** `PUT …/whitelabel-domain` — a full create-or-replace. */
export interface PutWhitelabelDomainRequest {
  domain: string;
  hosts: WhitelabelHostEntryRequest[];
}

export interface WhitelabelVerifyResultDto {
  prefix: string;
  hostname: string;
  hostnameType: HostnameType;
  /** Whether THIS run's DNS check matched. */
  matched: boolean;
  /** The persisted, sticky state after this run. */
  dnsVerified: boolean;
}

/** `POST …/whitelabel-domain/verify` — ACTIVE only when every hostname verified. */
export interface WhitelabelVerifyResponse {
  tenantId: number;
  domain: string | null;
  state: WhitelabelDomainState;
  activatedAt: string | null;
  allVerified: boolean;
  results: WhitelabelVerifyResultDto[];
  dnsConfigured: boolean;
  dnsRecords?: DnsRecordDto[] | null;
}

export interface GhlProbeOutcomeDto {
  ok: boolean;
  /** `null` when ok, or for a transport-level failure. */
  status: number | null;
  /** AUTH / NOT_FOUND / RATE_LIMITED / UNAVAILABLE / BAD_REQUEST; `null` when ok. */
  kind: string | null;
  upstreamMessage: string | null;
}

/** saas-auth `GhlIntegrationDiagnosisDto.Interpretation` @ `8208402` — all six values. */
export type GhlInterpretation =
  | 'LIKELY_MISSING_SCOPE'
  | 'LIKELY_CREDENTIAL_CORRUPT'
  | 'LIKELY_CREDENTIAL_INVALID'
  | 'HEALTHY'
  | 'UPSTREAM_UNAVAILABLE'
  | 'INDETERMINATE';

/** `POST …/ghl-integration/diagnose` — two live probes plus the server's verdict; never the token. */
export interface ResellerGhlIntegrationDiagnosisDto {
  resellerId: number;
  locationId: string | null;
  credentialStructurallyPlausible: boolean;
  contacts: GhlProbeOutcomeDto;
  customFields: GhlProbeOutcomeDto;
  interpretation: GhlInterpretation;
}

/* ---------------------------------------------------------------- add-ons (TMMPDM-0019, TMMAPI-0039)
 * `/v1/admin/addon-catalog…`, `/v1/admin/addons` and `/v1/admin/tenants/{slug}/addons…`. The views
 * (`CatalogView`, `TenantAddonView`, `ChargeView`) are `@JsonInclude(NON_NULL)` in tmm-api's
 * `AddonDtos` @ `bdaf6e0`: every Java `@Nullable` is OMITTED when unset, so it is optional here, never
 * `| null`; primitives, enums and lists are always present. `revenueYearMinor` is written on the
 * fleet list only; `charges` is empty on the fleet list. `tenantSlug` is `@Nullable` (a tenant the
 * registry no longer holds). YAML names: `AddonCancelRequest` = `CancelRequest`,
 * `AddonWaiveRequest` = `WaiveRequest` (renamed beside the subscription `Admin*` requests).
 */

export type AddonCatalogStatus = 'DRAFT' | 'ACTIVE' | 'RETIRED';
export type AddonPeriod = 'ANNUAL' | 'MONTHLY';
export type AddonAllowedBilling = 'CARD' | 'NET_FROM_PAYOUTS' | 'BOTH';
export type TenantAddonStatus =
  'OFFERED' | 'ACTIVE' | 'PAST_DUE' | 'LAPSED' | 'CANCELLED' | 'DECLINED' | 'WITHDRAWN';
export type AddonChargeStatus =
  'PENDING' | 'PAID' | 'FAILED' | 'ACTION_REQUIRED' | 'NETTING' | 'NETTED' | 'WAIVED' | 'REFUNDED';
export type AddonChargeMode = 'CARD' | 'NETTED';

export interface CatalogView {
  id: number;
  /** Upper-cased by the server on create. The PATCH path key. */
  kind: string;
  name: string;
  description: string;
  /** Integer minor units of `currency`; absent when the item has no default price. */
  defaultPriceMinor?: number;
  currency: string;
  period: AddonPeriod;
  status: AddonCatalogStatus;
  allowedBilling: AddonAllowedBilling;
  createdAt: string;
  updatedAt: string;
  /**
   * TMMAPI-0114: Java `long`, always written. `editableFields` is always `name`, `description`,
   * `defaultPriceMinor`, `allowedBilling` and `status`.
   */
  version: number;
  editableFields: string[];
}

export interface CatalogList {
  addons: CatalogView[];
}

/** YAML required: kind, name, description, period, currency. `allowedBilling` defaults to BOTH. */
export interface CatalogWriteRequest {
  kind: string;
  name: string;
  description: string;
  period: AddonPeriod;
  currency: string;
  defaultPriceMinor?: number;
  allowedBilling?: AddonAllowedBilling;
}

/** An omitted field is unchanged (a default price cannot be cleared through this call). */
export interface CatalogPatchRequest {
  name?: string;
  description?: string;
  defaultPriceMinor?: number;
  allowedBilling?: AddonAllowedBilling;
  status?: AddonCatalogStatus;
  /** TMMAPI-0114: the view's `version`. `0` is a real version and is sent. */
  version?: number;
}

/**
 * One period charge. `clientAction` (a Stripe SCA `clientSecret`) is for the tenant-admin accept
 * flow: it is on the wire, so it is typed — but the console never renders, logs, stores or copies it,
 * and no component reads it.
 */
export interface ChargeView {
  id: number;
  periodStart: string;
  periodEnd: string;
  amountMinor: number;
  currency: string;
  mode: AddonChargeMode;
  status: AddonChargeStatus;
  maskedCard?: string;
  attempt: number;
  lastError?: string;
  clientAction?: ClientAction;
}

export interface TenantAddonView {
  id: number;
  tenantId: number;
  tenantSlug?: string;
  addonKind: string;
  name: string;
  description?: string;
  status: TenantAddonStatus;
  priceMinor: number;
  currency: string;
  period: AddonPeriod;
  /** ISO dates. */
  termStart?: string;
  termEnd?: string;
  autoRenew: boolean;
  billingMode?: AddonBillingMode;
  allowedBilling: AddonAllowedBilling;
  maskedCard?: string;
  notes?: string;
  cancelAtTermEnd: boolean;
  /** ISO instants. */
  offeredAt: string;
  acceptedAt?: string;
  charges: ChargeView[];
  /** Server figure in this row's `currency` (fleet list only). Never summed across rows. */
  revenueYearMinor?: number;
}

export interface TenantAddonList {
  addons: TenantAddonView[];
}

/** YAML required: addonKind, priceMinor, currency, autoRenew. */
export interface OfferRequest {
  addonKind: string;
  priceMinor: number;
  currency: string;
  autoRenew: boolean;
  period?: AddonPeriod;
  allowedBilling?: AddonAllowedBilling;
  /** ISO date. */
  termStart?: string;
  notes?: string;
}

export interface AddonCancelRequest {
  atTermEnd: boolean;
  reason?: string;
}

export interface AddonWaiveRequest {
  reason: string;
}

/* ---------------------------------------------------------------- billing client config (TMMPDM-0082)
 * `GET /v1/admin/tenants/{slug}/billing/client-config` and `POST …/refresh` (TMMAPI-0049 / 0129) answer
 * `ScopedBillingClientConfig`. `provider`, `environment`, and `scope` are required non-null strings.
 * `flow`, `stripeAccount`, `publishableKey`, and `providerFields` stay optional (absent, never `null`).
 * `providerFields` is a string map. An empty cache answers 503
 * `PAY_API_UNAVAILABLE`; the refresh answers the same code both when pay-api reports the tenant
 * unconfigured (the cache is cleared) and when pay-api is unreachable (the cache is unchanged), with no
 * `details` to tell the two apart.
 */

export interface ScopedBillingClientConfig {
  provider: string;
  environment: string;
  flow?: string;
  scope: string;
  stripeAccount?: string;
  /** Public SDK key; the console shows only its last six characters. */
  publishableKey?: string;
  providerFields?: Record<string, string>;
}

/* ---------------------------------------------------------------- provision billing (TMMPDM-0084)
 * `POST /v1/admin/tenants/{slug}/billing/provision` (TMMAPI-0130): audited and idempotent. 200 answers
 * `AdminTenantBillingState`: `billingProvisionedAt` is required and never `null` here, `clientConfig`
 * is required and `null` while pay-api has none yet. Failures carry `details.slug` and
 * `details.reason`: 409 `BILLING_CONNECTION_CONFLICT` (`CONNECTION_EXISTS`); 503 `PAY_API_UNAVAILABLE`
 * (`STRIPE_ENVIRONMENT_UNSET`, `HOUSE_MODE_NOT_ALLOWED`, `HOUSE_MODE_UNAVAILABLE`, `ACTIVATION_REFUSED`
 * with pay-api's code in `details.payApiCode`, `PAY_API_UNAVAILABLE`). An unknown or suspended tenant is 404.
 */

export interface AdminTenantBillingState {
  billingProvisionedAt: string;
  clientConfig: ScopedBillingClientConfig | null;
}

/* ---------------------------------------------------------------- product settings (TMMPDM-0020)
 * `GET/PUT /v1/admin/product-settings`.
 */

export interface ProductSettingView {
  key: string;
  /** Present-and-`null` while unset. */
  value: string | null;
  updatedAt: string | null;
}

export interface ProductSettingsView {
  settings: ProductSettingView[];
  /**
   * TMMPDM-0098 (TMMAPI-0164): `TMMAPI_PAY_API_LEDGER_MODE`, served read-only and required. The
   * Operator sets it in the environment, never the console. A value other than `OFF` / `SHADOW` /
   * `LIVE` is not a mode.
   */
  ledgerMode: LedgerMode;
  /**
   * TMMPDM-0098 (TMMAPI-0162 item 36b, required by 0164): true from the moment the freeze is
   * recorded, and under LIVE. Required boolean, the same value on every partner ledger summary.
   * The console reads this field alone.
   */
  payoutActionsRetired: boolean;
}

/**
 * TMMAPI-0167: `settings` is optional; its map values are still nullable on the YAML. The console
 * sends only the changed keys, each a string, never null.
 */
export interface ProductSettingsRequest {
  settings?: Record<string, string>;
}

// ---------------------------------------------------------------------------------------------
// The partner ledger (TMMPDM-0097; re-pinned by TMMPDM-0098 to tmm-api `c24bc75`, blob
// `4b478d74dad7babd4f66da7cbc3b9e21e9edcaf9`; unchanged at the TMMPDM-0101 pin except
// `LedgerOpeningRequest.confirm`, which this file does not type). Every amount is the partner's
// own (MM-D-140) and is
// shown as sent: signed minor units in the payee's currency, never summed, converted or recomputed
// by the console. TMMAPI-0164 states `required` on these schemas. A key not in `required` may be
// absent and is never null. `lastStatement` is required and nullable.
// ---------------------------------------------------------------------------------------------

/** `TMMAPI_PAY_API_LEDGER_MODE` (item 13). From `LIVE` the old payout actions answer 410. */
export const LEDGER_MODES = ['OFF', 'SHADOW', 'LIVE'] as const;
export type LedgerMode = (typeof LEDGER_MODES)[number];

/** A statement's status (pay-api's settlement statement, projected by item 21). */
export const LEDGER_STATEMENT_STATUSES = [
  'CARRIED',
  'HELD',
  'NEGATIVE',
  'PAYABLE',
  'PAYOUT_FAILED',
  'COLLECTING',
  'PAYING',
  'PAID',
  'PAID_EXTERNALLY',
  'COLLECTED',
  'SETTLED',
] as const;
export type LedgerStatementStatus = (typeof LEDGER_STATEMENT_STATUSES)[number];

/**
 * A hold's kind (item 21 at `c09f02b5`). `PAYOUT_RETURNED` and `COLLECTION_CONFLICT` are released only by
 * operations. An unknown pay-api kind is served as `OTHER` with `rawKind`.
 */
export const LEDGER_HOLD_KINDS = [
  'FOR_CAUSE',
  'REVIEW',
  'TAX_ID_UNVERIFIED',
  'PAYOUT_RETURNED',
  'COLLECTION_CONFLICT',
  'OTHER',
] as const;
export type LedgerHoldKind = (typeof LEDGER_HOLD_KINDS)[number];

/**
 * A line's kind: the vertical's revenue lines (pay-api `LedgerBatchLineRequest.kind`) and pay-api's own
 * system lines (`LedgerLineView.kind`). A kind not listed here is shown by its code.
 */
export const LEDGER_LINE_KINDS = [
  'REVENUE_SHARE',
  'MARGIN',
  'AFFILIATE_COMMISSION',
  'COMMISSION_DEDUCTION',
  'PROCESSING_FEE',
  'AFFILIATE_BONUS',
  'MINIMUM_SHORTFALL',
  'ADJUSTMENT',
  'REVERSAL',
  'VOID',
  'PAYOUT',
  'PAYOUT_MANUAL',
  'PAYOUT_RETURNED',
  'COLLECTION',
] as const;
export type LedgerLineKind = (typeof LEDGER_LINE_KINDS)[number];

/**
 * An open (or released) hold. `kind` is an open string (the names in `LEDGER_HOLD_KINDS`, or one
 * this build doesn't know). `holdId`, `kind`, `amountMinor`, `overCap` and `openedAt` are required
 * and never null. `rawKind`, `reason` and `releasedAt` may be absent and are never null.
 */
export interface LedgerHoldView {
  holdId: string;
  kind: string;
  /** On `OTHER` only: the kind pay-api sent. Absent otherwise. */
  rawKind?: string;
  /** The amount held, minor units, as sent. A sent 0 stays 0. */
  amountMinor: number;
  /** A `REVIEW` over the transfer cap: only operations may release it. */
  overCap: boolean;
  reason?: string;
  openedAt: string;
  /** Absent while the hold is open. */
  releasedAt?: string;
}

/** A monthly statement: opening (carry-in) + lines = closing (carry-out), each as sent. */
export interface LedgerStatementView {
  statementId: string;
  /** `YYYY-MM` (UTC). */
  periodMonth: string;
  currency: string;
  /** A `LedgerStatementStatus`, or a status this console doesn't know yet (shown by its code). */
  status: string;
  openingMinor: number;
  linesMinor: number;
  closingMinor: number;
  lineCount?: number;
  closedAt?: string;
  /** Set once paid (a transfer's date, or a manual payment's `paidOn`). */
  paidOn?: string;
  paidMinor?: number;
  externalReference?: string;
}

/**
 * `GET /v1/admin/partners/{payeeRef}/ledger`: the balance, open holds and the last statement.
 * `payoutActionsRetired` is the same boolean as on product settings (item 36b).
 */
export interface PartnerLedgerView {
  payeeRef: string;
  /** The payee's currency: the balance's and an adjustment's. */
  currency: string;
  /** The running balance (pay-api `balanceMinor`); negative when the partner owes. Required. */
  balanceMinor: number;
  openHolds: LedgerHoldView[];
  /**
   * Required and nullable: `null` before the first statement closes.
   */
  lastStatement: LedgerStatementView | null;
  /** Item 36b, required by 0164. The console reads this boolean alone. */
  payoutActionsRetired: boolean;
}

/** `GET …/ledger/statements`: newest first, `afterId` paging. */
export interface LedgerStatementPage {
  statements: LedgerStatementView[];
  hasMore: boolean;
  /** Present when `hasMore`. */
  nextAfterId?: string;
}

/** A ledger line. `reversesLineId` links a `REVERSAL` to the line it reverses. */
export interface LedgerLineView {
  lineId: string;
  /** A `LedgerLineKind`, or a kind the console doesn't know yet (shown by its code). */
  kind: string;
  /** Signed: negative takes from the partner's balance. Absent is not zero. */
  amountMinor: number;
  currency: string;
  periodMonth?: string;
  createdAt: string;
  description?: string;
  reason?: string;
  reversesLineId?: string;
  /** Absent until a statement closes over the line. */
  statementId?: string;
  voided?: boolean;
}

/** `GET …/ledger/statements/{id}/lines` and `GET …/ledger/lines?unassigned=true`. */
export interface LedgerLinePage {
  lines: LedgerLineView[];
  hasMore: boolean;
  nextAfterId?: string;
}

/** `POST …/ledger/holds`, `…/release` and `…/void`: the reason (3–500), audited with the admin. */
export interface LedgerHoldRequest {
  reason: string;
}

/** `POST …/ledger/holds/{holdId}/void`: `confirmation` is the partner's name, as typed. */
export interface LedgerVoidRequest {
  reason: string;
  confirmation: string;
}

/**
 * `POST …/ledger/manual-payments`. `amountMinor` ≤ min(latest closing, balance) is tmm-api's check
 * (409 `STATEMENT_NOT_PAYABLE`); `paidOn` is required and never defaulted.
 */
export interface LedgerManualPaymentRequest {
  statementId: string;
  amountMinor: number;
  currency: string;
  /** `YYYY-MM-DD`. */
  paidOn: string;
  reference: string;
}

/** `POST …/ledger/adjustments`: a signed `ADJUSTMENT` (it replaces waive and mark collected). */
export interface LedgerAdjustmentRequest {
  amountMinor: number;
  currency: string;
  reason: string;
}

/**
 * One cut-over readiness check (item 26, 26a), as sent. `check` is `A2_CONFIRMED`,
 * `OLD_STATEMENTS_SETTLED`, `PAYEES_READY`, `OPENING_COMPUTED`, `DEACTIVATION_WINDOWS_RESOLVED`,
 * or a new one. `check`, `passed` and `failures` are required; none is null.
 */
export interface LedgerCutoverCheck {
  check: string;
  passed: boolean;
  /**
   * As sent. `OPENING_COMPUTED` entries are `"<payeeRef> <KIND> <sourceId> <amount>"`, or a
   * no-amount form (`<payeeRef> MISMATCH|NO_PAYEE|OTHER_CURRENCY`), or `<payeeRef>
   * TENANT_WITHOUT_RESELLER`. Other checks name partners or periods.
   */
  failures: string[];
}

/** One step of the fixed order (item 30, 26a), as the server judges it. */
export interface LedgerCutoverStep {
  /** `A2_CONFIRMATION`, `FREEZE`, `LIVE_VERTICALS_CONFIRMATION`, `OPENING`, or a new one. */
  step: string;
  /** False is not recorded. */
  recorded: boolean;
  recordedAt?: string;
  /** The server allows this step now. False does not enable the button. */
  allowed: boolean;
}

/** Outbox rows not yet posted (`PENDING` or `WAITING_PAYEE`) for one `YYYY-MM` period. */
export interface LedgerOutboxPeriod {
  periodMonth: string;
  rows: number;
}

/** `GET /v1/admin/billing/ledger/cutover`: the readiness read. */
export interface LedgerCutoverView {
  checks: LedgerCutoverCheck[];
  steps: LedgerCutoverStep[];
  pendingOutbox: LedgerOutboxPeriod[];
}

/**
 * The per-partner reconciliation (item 28), as the server computed it. `matches` is required.
 * The two amounts may be absent; absent is not zero.
 */
export interface LedgerReconciliation {
  matches: boolean;
  /** What tmm's old system would have paid on its next statement. */
  expectedMinor?: number;
  /** Opening + the post-close batches. */
  ledgerMinor?: number;
}

/**
 * One partner's opening adjustment (YAML `LedgerOpeningPartner`). `resellerId` and `tenantSlug`
 * are required on every entry (0164): a reseller's own id, or an affiliate's tenant's reseller.
 * A partner with no reseller is left out of `partners[]`.
 */
export interface LedgerOpeningRow {
  payeeRef: string;
  partnerName?: string;
  currency: string;
  /** Signed minor units: the balance carried on tmm's last paid statement. */
  figureMinor: number;
  reconciliation: LedgerReconciliation;
  resellerId: number;
  /** The slug of that reseller's live tenant. */
  tenantSlug: string;
}

/**
 * `POST /v1/admin/billing/ledger/opening` (a dry run unless `confirm: true`). `postable` and
 * `posted` are required. Post is enabled only by `postable`.
 */
export interface LedgerOpeningView {
  posted: boolean;
  /** The server's word that `confirm: true` would be accepted now. */
  postable: boolean;
  partners: LedgerOpeningRow[];
}

// Tickets: support cases and feature requests (TMMPDM-0109; TMMAPI-0181 U5, typed from its shipped YAML
// at `3a2d9f5f` by TMMPDM-0111). Product-wide: every tenant's tickets, triaged here; resellers
// don't see them. A field the YAML doesn't require (`duplicateOf`, `shippedIn`, `followers`, the
// requester's name and email, `tenantName`) is optional: omitted when unset, never null. Statuses,
// duplicates and followers are shown as sent: the server decides every transition.

export const TICKET_TYPES = ['SUPPORT_CASE', 'FEATURE_REQUEST'] as const;
export type TicketType = (typeof TICKET_TYPES)[number];

/** Item 28: a support case's statuses. */
export const SUPPORT_CASE_STATUSES = [
  'OPEN',
  'IN_PROGRESS',
  'WAITING_ON_YOU',
  'RESOLVED',
  'CLOSED',
] as const;

/** Item 28: a feature request's statuses. `DUPLICATE` is reached by marking a duplicate. */
export const FEATURE_REQUEST_STATUSES = [
  'SUBMITTED',
  'UNDER_REVIEW',
  'PLANNED',
  'IN_PROGRESS',
  'SHIPPED',
  'NOT_PLANNED',
  'DUPLICATE',
] as const;

/** Every ticket status, once (`IN_PROGRESS` is both types'). */
export const TICKET_STATUSES = [
  'OPEN',
  'IN_PROGRESS',
  'WAITING_ON_YOU',
  'RESOLVED',
  'CLOSED',
  'SUBMITTED',
  'UNDER_REVIEW',
  'PLANNED',
  'SHIPPED',
  'NOT_PLANNED',
  'DUPLICATE',
] as const;
export type TicketStatus = (typeof TICKET_STATUSES)[number];

export const TICKET_AUTHOR_KINDS = ['MEMBER', 'STAFF', 'SYSTEM'] as const;
export type TicketAuthorKind = (typeof TICKET_AUTHOR_KINDS)[number];

export const TICKET_VISIBILITIES = ['PUBLIC', 'INTERNAL'] as const;
export type TicketVisibility = (typeof TICKET_VISIBILITIES)[number];

/** One ticket on the list. `number` is the product-wide sequence; its prefix (SC-, FR-) is its type's. */
export interface TicketRow {
  number: number;
  type: TicketType;
  /** At most 120 characters. */
  title: string;
  /** A `TicketStatus`, or one this console doesn't know yet (shown by its code, neutral). */
  status: string;
  /** The addressed tenant (tmm-api addresses tenants by slug). */
  tenantSlug: string;
  tenantName?: string;
  /** The requester by name; after erasure, the pseudonym (item 32). The id is never shown. */
  requesterName?: string;
  requesterEmail?: string;
  /** On a canonical ticket: how many requesters follow it (item 30). */
  followers?: number;
  /** The canonical ticket's number, when this one is a duplicate. */
  duplicateOf?: number;
  /** Free text, e.g. a release note. */
  shippedIn?: string;
  createdAt: string;
  updatedAt: string;
}

/** `GET /v1/admin/tickets`: one server page, newest first. */
export interface TicketPage {
  tickets: TicketRow[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface TicketListQuery {
  type: TicketType;
  status?: string | undefined;
  /** A tenant's slug. */
  tenant?: string | undefined;
  q?: string | undefined;
  /** ISO instant: created at or after. Omitted for "Any time". */
  from?: string | undefined;
  /** 0-based, as the server counts. */
  page?: number | undefined;
  size?: number | undefined;
}

/** One update on a ticket (item 28). A status change writes a `SYSTEM` public update. */
export interface TicketUpdateView {
  id: number;
  authorKind: TicketAuthorKind;
  visibility: TicketVisibility;
  /** At most 4000 characters. */
  body: string;
  createdAt: string;
  /**
   * `MEMBER`: the requester's name (the pseudonym once erased); `STAFF`: the staff person's display
   * name, which isn't always known (never the email). Omitted otherwise: a `STAFF` update without it
   * shows "Staff".
   */
  authorName?: string;
  /** On a status change: the status it moved to. */
  toStatus?: string;
  /** TMMPDM-0110 (U7): files the member attached to this update, when the server lists them. */
  attachments?: TicketAttachmentView[];
}

/**
 * A file on a ticket (TMMPDM-0110; the YAML's `TicketAttachment`). The console lists them and
 * downloads one through the axios factory, never rendering it (no image, document or HTML preview).
 * Absent metadata means no block. The YAML's `kind` is not read.
 */
export interface TicketAttachmentView {
  /** What `GET …/tickets/{number}/attachments/{attachmentId}` addresses (int64). */
  attachmentId: number;
  name: string;
  contentType: string;
  sizeBytes: number;
}

/** `GET /v1/admin/tickets/{number}`: the ticket and every update, public and internal. */
export interface TicketView extends TicketRow {
  /** At most 4000 characters. */
  description: string;
  /**
   * The assistant turn the ticket was drafted in, if any (item 28). Its presence is all the console
   * reads ("Drafted with the assistant"): a session's contents are never shown.
   */
  draftTurnId?: number;
  updates: TicketUpdateView[];
  /** TMMPDM-0110 (U7 item 46): files filed with the ticket, when the server lists them. */
  attachments?: TicketAttachmentView[];
}

/** `POST …/tickets/{number}/updates`: a public update to the member, or an internal note. */
export interface TicketUpdateRequest {
  visibility: TicketVisibility;
  body: string;
}

/** `POST …/tickets/{number}/status`: 409 when the type doesn't allow it from the current status. */
export interface TicketStatusRequest {
  status: string;
}

/** `POST …/tickets/{number}/duplicate`: the canonical ticket's number. */
export interface TicketDuplicateRequest {
  duplicateOf: number;
}

/** `POST …/tickets/{number}/shipped-in`: free text; an empty string clears it. */
export interface TicketShippedInRequest {
  shippedIn: string;
}

// Announcements (TMMPDM-0110; TMMAPI-0181 U5 item 32a, typed from its shipped YAML at `3a2d9f5f` by
// TMMPDM-0111, which matches 0110's reading). The product admin authors news for every customer or for
// chosen tenants; members read it in the Support & features panel. A field the YAML doesn't require
// (`publishAt` before scheduling, `expiresAt`, `relatedTicket`, `tenantIds` for an `ALL` audience,
// `authorName`) is optional: omitted when unset, never null. `state` and `readCount` are shown as
// sent: the console never derives a state from the times. Only a `DRAFT` is changed or deleted
// (409 `ANNOUNCEMENT_NOT_DRAFT` otherwise); only a `PUBLISHED` one is expired (409
// `ANNOUNCEMENT_NOT_PUBLISHED {state}` otherwise).

export const ANNOUNCEMENT_KINDS = ['NEWS', 'FEATURE', 'MAINTENANCE', 'IMPORTANT'] as const;
export type AnnouncementKind = (typeof ANNOUNCEMENT_KINDS)[number];

export const ANNOUNCEMENT_STATES = ['DRAFT', 'SCHEDULED', 'PUBLISHED', 'EXPIRED'] as const;
export type AnnouncementState = (typeof ANNOUNCEMENT_STATES)[number];

/** Everyone, or the tenants listed in `tenantIds` (saas-auth tenant ids, as `TenantView.id`). */
export const ANNOUNCEMENT_AUDIENCES = ['ALL', 'TENANTS'] as const;
export type AnnouncementAudience = (typeof ANNOUNCEMENT_AUDIENCES)[number];

/** One announcement on the list. */
export interface AnnouncementRow {
  id: number;
  /** At most 120 characters. */
  title: string;
  /** An `AnnouncementKind`, or one this console doesn't know yet (shown by its code, neutral). */
  kind: string;
  /** An `AnnouncementState` as the server decides it, or one this console doesn't know yet. */
  state: string;
  audience: AnnouncementAudience;
  /** The chosen tenants, on a `TENANTS` audience. */
  tenantIds?: number[];
  /** When it goes (or went) live; absent on a draft. */
  publishAt?: string;
  expiresAt?: string;
  pinned: boolean;
  /** Shown once, as a pop-up, to everyone in the audience on their next visit while unread. */
  popup: boolean;
  /** A feature request's bare number (`FR-1002` is `1002`), so its followers see it. */
  relatedTicket?: number;
  /** How many people have read it, as the server counts. */
  readCount: number;
  createdAt: string;
  updatedAt: string;
}

/** `GET /v1/admin/announcements/{id}`: the row and its body. */
export interface AnnouncementView extends AnnouncementRow {
  /** At most 8000 characters: the help library's small Markdown subset; `{productName}` substituted for members. */
  body: string;
  /** The staff person's display name, when the server knows it (never the email); absent shows "Staff". */
  authorName?: string;
}

/** `GET /v1/admin/announcements`: one server page, newest first. */
export interface AnnouncementPage {
  announcements: AnnouncementRow[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface AnnouncementListQuery {
  state?: string | undefined;
  kind?: string | undefined;
  /** 0-based, as the server counts. */
  page?: number | undefined;
  size?: number | undefined;
}

/** `POST /v1/admin/announcements` (a draft) and `PUT …/{id}` (a draft only): the editable fields. */
export interface AnnouncementWrite {
  title: string;
  body: string;
  kind: AnnouncementKind;
  audience: AnnouncementAudience;
  /** Sent only for a `TENANTS` audience. */
  tenantIds?: number[];
  /** Sent only when set: no expiry otherwise. */
  expiresAt?: string;
  pinned: boolean;
  popup: boolean;
  /** Sent only when a feature request is chosen. */
  relatedTicket?: number;
}

/** `POST …/announcements/{id}/publish`: no `publishAt` publishes now; a future instant schedules it. */
export interface AnnouncementPublishRequest {
  publishAt?: string;
}

// Merchant knowledge (TMMPDM-0112). TMMPDM-0113: vendored from tmm-api `f7c843fb`, blob
// `f2a3324a3ea15f9fd036f87de0401cbfdee9b7ee` (TMMAPI-0194 and TMMAPI-0195 shipped): `MerchantPatternList`,
// `MerchantPatternView`, `MerchantPatternGate`, `MerchantPatternApproveRequest`,
// `MerchantPatternRejectRequest`, `NamingQualityReport` and its three row schemas, `InstitutionRequestList`,
// `InstitutionRequestRow`, `InstitutionRequestAdd` and `Institution`. A field the YAML requires is
// required here; one it may omit is `?`; one it types `[T, "null"]` is `T | null`. TMMPDM-0112's
// spec-text reading is reconciled in the TMMPDM-0113 delivery's Step 0 table.
//
// MM-D-151 / MM-D-152: merchants are public facts and people are private. Nothing here types a
// member, tenant or owner: a pattern carries counts only, and an unlisted bank its typed name and
// country. The console renders only the fields typed here (`knowledge.identity.test.ts`).

/** 0194 U1 item 1: a pattern's lifecycle. Only an approval promotes; retirement re-queues it. */
export const MERCHANT_PATTERN_STATES = ['CANDIDATE', 'APPROVED', 'RETIRED'] as const;
export type MerchantPatternState = (typeof MERCHANT_PATTERN_STATES)[number];

/** A pattern's kind as the server sends it: the payee kind enum. A stored pattern is never `PERSON`. */
export type MerchantPatternWireKind = 'VENDOR' | 'PERSON' | 'OTHER';

/** The kinds an approval may set (0194 item 6: a business, `VENDOR` or `OTHER`, never `PERSON`). */
export const MERCHANT_PATTERN_KINDS = ['VENDOR', 'OTHER'] as const;
export type MerchantPatternKind = (typeof MERCHANT_PATTERN_KINDS)[number];

/** The six gates, in the YAML's order (`MerchantPatternGate.gate`). */
export const MERCHANT_PATTERN_GATES = [
  'NOT_P2P',
  'MOSTLY_BUSINESS',
  'MERCHANT_MARKERS',
  'NOT_PERSONAL_NAME',
  'THRESHOLD',
  'REDACTED',
] as const;
export type MerchantPatternGateKey = (typeof MERCHANT_PATTERN_GATES)[number];

/** One gate's result, as the server computed it (recomputed as evidence lands). */
export interface MerchantPatternGate {
  gate: MerchantPatternGateKey;
  passed: boolean;
}

/** `MerchantPatternView`: one pattern on the queue. Counts only: never an owner hash, tenant or member. */
export interface MerchantPatternRow {
  id: number;
  /** The redacted, normalized key 0193 matches on (never the raw bank text). */
  pattern: string;
  /** The most chosen name, or the approval's once approved; `""` when every chosen name was withheld. */
  proposedName: string;
  /** The most chosen kind, or the approval's once approved; `null` when no kind was chosen. */
  kind: MerchantPatternWireKind | null;
  state: MerchantPatternState;
  confirmations: number;
  edits: number;
  forgets: number;
  distinctMembers: number;
  distinctTenants: number;
  /** Each gate's result, in the YAML's order: detail, never combined by the console. */
  gates: MerchantPatternGate[];
  /**
   * The server's verdict: every gate passed. Typed as sent; the tabs split on the `promotable` filter,
   * and the console reads no decision from this field.
   */
  promotable: boolean;
}

/** `MerchantPatternList` (`GET /v1/admin/merchant-patterns`): one server page, 0-based. */
export interface MerchantPatternPage {
  patterns: MerchantPatternRow[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface MerchantPatternListQuery {
  state: MerchantPatternState;
  /** The server's `promotable=true|false` filter, applied in SQL; sent only for the candidate tabs. */
  promotable?: boolean | undefined;
  q?: string | undefined;
  /** 0-based, as the server counts; `size` is 20 by default and 100 at most. */
  page?: number | undefined;
  size?: number | undefined;
}

/**
 * `MerchantPatternApproveRequest {name?, kind?}`: a field is sent only when it was corrected. The name
 * is 1-120 characters once trimmed. The YAML also takes `PERSON`, which fails `MOSTLY_BUSINESS`; the
 * console never sends it.
 */
export interface MerchantPatternApproveRequest {
  name?: string;
  kind?: MerchantPatternKind;
}

/** `MerchantPatternRejectRequest {reason}`: 1-500 characters once trimmed, kept in the audit only. */
export interface MerchantPatternRejectRequest {
  reason: string;
}

/** `NamingQualitySourceRow.source`: how a proposal was made. */
export const NAMING_SOURCES = ['KNOWN_MERCHANT', 'BANK_TEXT', 'AI'] as const;
export type NamingSource = (typeof NAMING_SOURCES)[number];

/**
 * The counts every naming-quality row carries, and the rates as the server computed them, each a
 * fraction of 1 (0.85 is 85 %). A rate is absent when `named` is 0; the console never computes one.
 */
export interface NamingQualityCounts {
  /** Proposals made in the window. */
  named: number;
  accepted: number;
  edited: number;
  forgotten: number;
  acceptanceRate?: number;
  editRate?: number;
  forgetRate?: number;
}

/** `NamingQualitySourceRow`. */
export interface NamingQualityBySource extends NamingQualityCounts {
  source: NamingSource;
}

/** `NamingQualityInstitutionRow`: both catalog fields are absent on the row for accounts with none. */
export interface NamingQualityByInstitution extends NamingQualityCounts {
  /** The institution catalog's id. Typed, never shown. */
  institutionId?: number;
  /** The bank's catalog name (a public fact). Never the account's own free-text institution. */
  institutionName?: string;
}

/** `NamingQualityModelRow`: AI proposals. */
export interface NamingQualityByModel extends NamingQualityCounts {
  model: string;
  promptVersion: string;
}

/** `NamingQualityReport` (`GET /v1/admin/naming-quality?from&to`): read-only, counts only. */
export interface NamingQualityReport {
  bySource: NamingQualityBySource[];
  byInstitution: NamingQualityByInstitution[];
  byModel: NamingQualityByModel[];
}

/**
 * `from` and `to` as civil dates (`YYYY-MM-DD`), both whole days included: the YAML reads a date in
 * the caller's timezone (UTC for a product admin).
 */
export interface NamingQualityQuery {
  from: string;
  to: string;
}

/** `InstitutionRequestAdd.kind` and `Institution.kind`. */
export const INSTITUTION_KINDS = ['BANK', 'CREDIT_UNION', 'OTHER'] as const;
export type InstitutionKind = (typeof INSTITUTION_KINDS)[number];

/**
 * `InstitutionRequestRow`: the open requests of one typed name (case- and accent-folded) and country,
 * grouped. The typed name and the country only, no member identity.
 */
export interface InstitutionRequestRow {
  /** The group's latest request; add and dismiss take it. */
  id: number;
  /** The name as the latest request typed it. */
  typedName: string;
  /** ISO 3166-1 alpha-2. */
  country: string;
  /** How many open requests the row stands for (at least 1). */
  count: number;
  /** The latest of them. */
  requestedAt: string;
}

/** `InstitutionRequestList`: open only, newest first, at most 200 rows, no paging in v1. */
export interface InstitutionRequestList {
  requests: InstitutionRequestRow[];
}

/** At most this many rows answer `GET /v1/admin/institution-requests`. */
export const INSTITUTION_REQUESTS_MAX = 200;

/**
 * `InstitutionRequestAdd {name, country, city?, kind}`: creates an `ADMIN` institution and closes every
 * open request of the row's typed name and country. Name 1-200 and city at most 100 characters once
 * trimmed.
 */
export interface InstitutionAddRequest {
  name: string;
  /** ISO 3166-1 alpha-2. */
  country: string;
  /** Sent only when entered. */
  city?: string;
  kind: InstitutionKind;
}

/** `Institution`: the catalog institution an add answers. */
export interface CatalogInstitution {
  id: number;
  name: string;
  /** ISO 3166-1 alpha-2. */
  country: string;
  city: string | null;
  region: string | null;
  bic: string | null;
  kind: InstitutionKind;
  source: 'FDIC' | 'NCUA' | 'BIC_OPEN' | 'ADMIN';
  sourceId: string;
  aliases: string[];
  /** US routing numbers (9 digits). */
  routing: string[];
  active: boolean;
  updatedAt: string;
}
